<!-- Page Header -->
<div class="flex flex-wrap items-center justify-between gap-3 mb-6">
  <h2 class="text-xl font-semibold text-gray-800 dark:text-white/90">Chats</h2>
  <nav>
    <ol class="flex items-center gap-1.5">
      <li>
        <a routerLink="/" class="inline-flex items-center gap-1.5 text-sm text-gray-500 dark:text-gray-400">
          Home
          <svg width="17" height="16" viewBox="0 0 17 16" fill="none" class="stroke-current">
            <path d="M6.0765 12.667L10.2432 8.50033L6.0765 4.33366" stroke-width="1.2" stroke-linecap="round" stroke-linejoin="round"/>
          </svg>
        </a>
      </li>
      <li class="text-sm text-gray-800 dark:text-white/90">Chats</li>
    </ol>
  </nav>
</div>

<!-- Main Chat Layout -->
<div class="h-[calc(100vh-150px)] overflow-hidden sm:h-[calc(100vh-190px)]">
  <div class="flex h-full gap-0 xl:gap-5">

    <!-- ═══════════════════════════════════════════════════════════════════════
         SIDEBAR
    ═══════════════════════════════════════════════════════════════════════ -->
    <div class="flex flex-col w-full xl:w-[320px] flex-shrink-0 overflow-hidden rounded-2xl border border-gray-200 bg-white dark:border-gray-800 dark:bg-white/[0.03]"
         [class.hidden]="(activeConversation$ | async) !== null && !isMobileSidebarOpen"
         [class.xl:flex]="true">

      <!-- Sidebar Header -->
      <div class="px-4 pt-4 pb-3 sm:px-5 sm:pt-5 flex-shrink-0">
        <div class="flex items-center justify-between mb-3">
          <h3 class="text-lg font-semibold text-gray-800 dark:text-white/90">Messages</h3>
        <div class="flex items-center gap-1">
          <!-- New Message button (pencil icon — Instagram style) -->
          <button (click)="openNewMessageModal()"
                  title="New Message"
                  class="flex items-center justify-center h-8 w-8 rounded-lg text-gray-500 hover:bg-gray-100 hover:text-gray-800 dark:text-gray-400 dark:hover:bg-white/10 dark:hover:text-white transition-colors">
            <svg width="18" height="18" viewBox="0 0 24 24" fill="none">
              <path d="M11 4H4C3.46957 4 2.96086 4.21071 2.58579 4.58579C2.21071 4.96086 2 5.46957 2 6V20C2 20.5304 2.21071 21.0391 2.58579 21.4142C2.96086 21.7893 3.46957 22 4 22H18C18.5304 22 19.0391 21.7893 19.4142 21.4142C19.7893 21.0391 20 20.5304 20 20V13" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
              <path d="M18.5 2.50023C18.8978 2.1024 19.4374 1.87891 20 1.87891C20.5626 1.87891 21.1022 2.1024 21.5 2.50023C21.8978 2.89805 22.1213 3.43762 22.1213 4.00023C22.1213 4.56284 21.8978 5.1024 21.5 5.50023L12 15.0002L8 16.0002L9 12.0002L18.5 2.50023Z" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
            </svg>
          </button>
          <!-- New Group button -->
          <button (click)="openGroupModal()"
                  title="New Group"
                  class="flex items-center justify-center h-8 w-8 rounded-lg text-gray-500 hover:bg-gray-100 hover:text-gray-800 dark:text-gray-400 dark:hover:bg-white/10 dark:hover:text-white transition-colors">
            <svg width="18" height="18" viewBox="0 0 24 24" fill="none">
              <path d="M17 10H19C21 10 22 9 22 7V5C22 3 21 2 19 2H17C15 2 14 3 14 5V7C14 9 15 10 17 10Z" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
              <path d="M2 17V19C2 21 3 22 5 22H7C9 22 10 21 10 19V17C10 15 9 14 7 14H5C3 14 2 15 2 17Z" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
              <path d="M12 6H8C5.8 6 5 6.8 5 9V11" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
              <path d="M12 18H16C18.2 18 19 17.2 19 15V13" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
            </svg>
          </button>
          <!-- Chat settings (auto-show media) -->
          <div class="relative" (click)="$event.stopPropagation()">
            <button (click)="toggleChatSettingsMenu($event)"
                    title="Chat settings"
                    class="flex items-center justify-center h-8 w-8 rounded-lg text-gray-500 hover:bg-gray-100 hover:text-gray-800 dark:text-gray-400 dark:hover:bg-white/10 dark:hover:text-white transition-colors">
              <svg width="18" height="18" viewBox="0 0 24 24" fill="none">
                <path d="M10.325 4.317c.426-1.756 2.924-1.756 3.35 0a1.724 1.724 0 002.573 1.066c1.543-.94 3.31.826 2.37 2.37a1.724 1.724 0 001.065 2.572c1.756.426 1.756 2.924 0 3.35a1.724 1.724 0 00-1.066 2.573c.94 1.543-.826 3.31-2.37 2.37a1.724 1.724 0 00-2.572 1.065c-.426 1.756-2.924 1.756-3.35 0a1.724 1.724 0 00-2.573-1.066c-1.543.94-3.31-.826-2.37-2.37a1.724 1.724 0 00-1.065-2.572c-1.756-.426-1.756-2.924 0-3.35a1.724 1.724 0 001.066-2.573c-.94-1.543.826-3.31 2.37-2.37.996.608 2.296.07 2.572-1.065z" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
                <circle cx="12" cy="12" r="3" stroke="currentColor" stroke-width="1.5"/>
              </svg>
            </button>
            <div *ngIf="showChatSettingsMenu"
                 class="absolute right-0 z-50 mt-1 w-64 rounded-xl border border-gray-200 bg-white p-3 shadow-xl dark:border-gray-700 dark:bg-gray-800">
              <div class="flex items-start justify-between gap-3">
                <div>
                  <p class="text-sm font-medium text-gray-800 dark:text-white/90">Auto-show media</p>
                  <p class="mt-0.5 text-xs text-gray-500 dark:text-gray-400">
                    Automatically load photos and videos in chats. Turn off to save data — tap to view instead.
                  </p>
                </div>
                <button (click)="toggleAutoShowMedia()"
                        role="switch"
                        [attr.aria-checked]="autoShowMedia"
                        class="relative inline-flex h-5 w-9 flex-shrink-0 items-center rounded-full transition-colors"
                        [class.bg-brand-500]="autoShowMedia"
                        [class.bg-gray-300]="!autoShowMedia"
                        [class.dark:bg-gray-600]="!autoShowMedia">
                  <span class="inline-block h-3.5 w-3.5 transform rounded-full bg-white transition-transform"
                        [style.transform]="autoShowMedia ? 'translateX(18px)' : 'translateX(3px)'"></span>
                </button>
              </div>
            </div>
          </div>
        </div>
        </div>

        <!-- Search -->
        <div class="relative mb-3">
          <svg class="absolute left-3 top-1/2 -translate-y-1/2 fill-gray-400 dark:fill-gray-500 flex-shrink-0" width="16" height="16" viewBox="0 0 20 20">
            <path fill-rule="evenodd" clip-rule="evenodd" d="M3.04199 9.37381C3.04199 5.87712 5.87735 3.04218 9.37533 3.04218C12.8733 3.04218 15.7087 5.87712 15.7087 9.37381C15.7087 12.8705 12.8733 15.7055 9.37533 15.7055C5.87735 15.7055 3.04199 12.8705 3.04199 9.37381ZM9.37533 1.54218C5.04926 1.54218 1.54199 5.04835 1.54199 9.37381C1.54199 13.6993 5.04926 17.2055 9.37533 17.2055C11.2676 17.2055 13.0032 16.5346 14.3572 15.4178L17.1773 18.2381C17.4702 18.531 17.945 18.5311 18.2379 18.2382C18.5308 17.9453 18.5309 17.4704 18.238 17.1775L15.4182 14.3575C16.5367 13.0035 17.2087 11.2671 17.2087 9.37381C17.2087 5.04835 13.7014 1.54218 9.37533 1.54218Z"/>
          </svg>
          <input type="text" [(ngModel)]="searchQuery" placeholder="Search conversations…"
                 class="w-full h-9 rounded-lg border border-gray-200 bg-gray-50 pl-9 pr-3 text-sm text-gray-800 placeholder:text-gray-400 focus:border-brand-300 focus:outline-none focus:ring-2 focus:ring-brand-500/10 dark:border-gray-700 dark:bg-gray-800 dark:text-white/90 dark:placeholder:text-white/30">
        </div>

        <!-- Tabs: Chats / Groups / Requests -->
        <div class="flex gap-1 p-1 bg-gray-100 dark:bg-gray-800 rounded-lg">
          <button *ngFor="let tab of tabs"
            (click)="setTab(tab.key)"
            [class.bg-white]="activeTab === tab.key"
            [class.dark:bg-gray-700]="activeTab === tab.key"
            [class.shadow-sm]="activeTab === tab.key"
            [class.text-gray-800]="activeTab === tab.key"
            [class.dark:text-white]="activeTab === tab.key"
            [class.text-gray-500]="activeTab !== tab.key"
            class="flex-1 flex items-center justify-center gap-1.5 py-1.5 text-xs font-medium rounded-md transition-all">
            <span>{{ tab.label }}</span>
            <span *ngIf="getTabUnreadCount(tab.key) as count"
                  [class.bg-brand-500]="activeTab === tab.key"
                  [class.text-white]="activeTab === tab.key"
                  [class.bg-gray-200]="activeTab !== tab.key"
                  [class.text-gray-600]="activeTab !== tab.key"
                  [class.dark:bg-gray-600]="activeTab !== tab.key"
                  [class.dark:text-gray-300]="activeTab !== tab.key"
                  class="min-w-[18px] h-[18px] px-1 inline-flex items-center justify-center rounded-full text-[10px] font-semibold leading-none">
              {{ count > 99 ? '99+' : count }}
            </span>
          </button>
        </div>
      </div>

      <!-- Conversation List -->
      <div class="flex-1 overflow-y-auto px-2 pb-4 custom-scrollbar">
        <ng-container *ngIf="conversations$ | async as conversations">

          <!-- Loading skeleton -->
          <ng-container *ngIf="loadingConversations$ | async">
            <div *ngFor="let i of [1,2,3,4,5]"
                 class="flex items-center gap-3 p-3 rounded-xl animate-pulse">
              <div class="h-11 w-11 rounded-full bg-gray-200 dark:bg-gray-700 flex-shrink-0"></div>
              <div class="flex-1 space-y-2">
                <div class="h-3 w-24 rounded bg-gray-200 dark:bg-gray-700"></div>
                <div class="h-2.5 w-36 rounded bg-gray-100 dark:bg-gray-800"></div>
              </div>
            </div>
          </ng-container>

          <!-- Empty state -->
          <div *ngIf="!(loadingConversations$ | async) && getFilteredConversations(conversations).length === 0"
               class="flex flex-col items-center justify-center py-16 text-center px-4">
            <svg class="mb-3 text-gray-300 dark:text-gray-600" width="48" height="48" viewBox="0 0 24 24" fill="none">
              <path d="M21 15C21 15.5304 20.7893 16.0391 20.4142 16.4142C20.0391 16.7893 19.5304 17 19 17H7L3 21V5C3 4.46957 3.21071 3.96086 3.58579 3.58579C3.96086 3.21071 4.46957 3 5 3H19C19.5304 3 20.0391 3.21071 20.4142 3.58579C20.7893 3.96086 21 4.46957 21 5V15Z" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
            </svg>
            <p class="text-sm font-medium text-gray-500 dark:text-gray-400">
              {{ activeTab === 'requests' ? 'No message requests' : 'No conversations yet' }}
            </p>
            <p class="mt-1 text-xs text-gray-400 dark:text-gray-500">
              {{ activeTab === 'requests' ? 'New requests will appear here' : 'Find a friend and start chatting' }}
            </p>
          </div>

          <!-- Conversation items -->
          <ng-container *ngIf="!(loadingConversations$ | async)">
            <div *ngFor="let conv of getFilteredConversations(conversations); trackBy: trackByConv"
                 (click)="selectConversation(conv)"
                 [class.bg-brand-50]="(activeConversation$ | async)?._id === conv._id"
                 [class.dark:bg-brand-900\/20]="(activeConversation$ | async)?._id === conv._id"
                 class="flex items-center gap-3 p-3 rounded-xl cursor-pointer hover:bg-gray-50 dark:hover:bg-white/[0.03] transition-colors">

              <!-- Avatar -->
              <div class="relative flex-shrink-0">
                <img [src]="getConversationAvatar(conv)"
                     [alt]="getConversationName(conv)"
                     class="h-11 w-11 rounded-full object-cover object-center"
                     onerror="this.src='/images/user/user-default.svg'">
                <!-- Online dot (DM only) -->
                <span *ngIf="conv.type === 'DM' && isOnline(conv)"
                      class="absolute bottom-0 right-0 block h-3 w-3 rounded-full border-2 border-white bg-success-500 dark:border-gray-900"></span>
                <!-- Group badge -->
                <span *ngIf="conv.type === 'GROUP'"
                      class="absolute -bottom-0.5 -right-0.5 flex h-4 w-4 items-center justify-center rounded-full bg-brand-500 border border-white dark:border-gray-900">
                  <svg width="8" height="8" viewBox="0 0 24 24" fill="white">
                    <path d="M17 21v-2a4 4 0 00-4-4H5a4 4 0 00-4 4v2M23 21v-2a4 4 0 00-3-3.87M16 3.13a4 4 0 010 7.75" stroke="white" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
                  </svg>
                </span>
              </div>

              <!-- Info -->
              <div class="flex-1 min-w-0">
                <div class="flex items-center justify-between gap-1 mb-0.5">
                  <span class="text-sm font-semibold text-gray-800 dark:text-white/90 truncate">
                    {{ getConversationName(conv) }}
                  </span>
                  <span class="text-xs text-gray-400 dark:text-gray-500 flex-shrink-0">
                    {{ conv.lastMessageAt ? formatTime(conv.lastMessageAt) : '' }}
                  </span>
                </div>
                <div class="flex items-center justify-between gap-1">
                  <p class="text-xs text-gray-500 dark:text-gray-400 truncate">
                    <ng-container *ngIf="conv.type === 'DM' && conv.isBlocked; else requestOrLastMsgTpl">
                      <em>{{ conv.blockedByMe ? 'Blocked' : "You can't message this contact" }}</em>
                    </ng-container>
                    <ng-template #requestOrLastMsgTpl>
                      <ng-container *ngIf="conv.messageRequest?.status === 'PENDING'; else lastMsgTpl">
                        <em>Message request</em>
                      </ng-container>
                    </ng-template>
                    <ng-template #lastMsgTpl>
                      {{ getLastMessagePreview(conv) }}
                    </ng-template>
                  </p>
                  <!-- Unread badge -->
                  <span *ngIf="conv.unreadCount > 0"
                        style="background-color:#D31148"
                        class="flex-shrink-0 flex h-5 min-w-5 items-center justify-center rounded-full px-1.5 text-[10px] font-bold text-white">
                    {{ conv.unreadCount > 99 ? '99+' : conv.unreadCount }}
                  </span>
                </div>
              </div>
            </div>
          </ng-container>
        </ng-container>
      </div>
    </div>
    <!-- END SIDEBAR -->

    <!-- ═══════════════════════════════════════════════════════════════════════
         CHAT WINDOW
    ═══════════════════════════════════════════════════════════════════════ -->
    <div class="flex flex-col flex-1 min-w-0 overflow-hidden rounded-2xl border border-gray-200 bg-white dark:border-gray-800 dark:bg-white/[0.03]"
         [class.hidden]="(activeConversation$ | async) === null"
         [class.xl:flex]="true"
         [class.flex]="(activeConversation$ | async) !== null">

      <ng-container *ngIf="activeConversation$ | async as conv; else noConversation">

        <!-- ── Chat Header ──────────────────────────────────────────────────── -->
        <div class="flex items-center justify-between gap-2 border-b border-gray-200 px-3 py-3 sm:px-4 dark:border-gray-800 flex-shrink-0">
          <div class="flex min-w-0 items-center gap-2 sm:gap-3">
            <!-- Back button (mobile) -->
            <button (click)="isMobileSidebarOpen = true; chatService.closeConversation()"
                    class="xl:hidden p-1 text-gray-500 hover:text-gray-800 dark:text-gray-400">
              <svg width="20" height="20" viewBox="0 0 24 24" fill="none">
                <path d="M19 12H5M5 12L12 19M5 12L12 5" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
              </svg>
            </button>

            <!-- Avatar -->
            <div class="relative flex-shrink-0"
                 [class.cursor-pointer]="conv.type === 'DM'"
                 (click)="conv.type === 'DM' && goToUserProfile(getOtherParticipant(conv), $event)">
              <img [src]="getConversationAvatar(conv)" [alt]="getConversationName(conv)"
                   class="h-10 w-10 rounded-full object-cover"
                   onerror="this.src='/images/user/user-default.svg'">
              <span *ngIf="conv.type === 'DM' && isOnline(conv)"
                    class="absolute bottom-0 right-0 block h-2.5 w-2.5 rounded-full border-2 border-white bg-success-500 dark:border-gray-900"></span>
            </div>

            <!-- Name + status -->
            <div class="min-w-0">
              <h5 class="truncate text-sm font-semibold text-gray-800 dark:text-white/90"
                  [class.cursor-pointer]="conv.type === 'DM'"
                  [class.hover:underline]="conv.type === 'DM'"
                  (click)="conv.type === 'DM' && goToUserProfile(getOtherParticipant(conv), $event)">
                {{ getConversationName(conv) }}
              </h5>
              <p class="truncate text-xs text-gray-400 dark:text-gray-500">
                <ng-container *ngIf="conv.type === 'GROUP'">
                  {{ conv.memberCount }} members
                </ng-container>
                <ng-container *ngIf="conv.type === 'DM'">
                  {{ getPresenceLabel(conv) }}
                </ng-container>
              </p>
            </div>
          </div>

          <!-- Header actions — shown as icons at every size (no overflow menu) -->
          <div class="flex flex-shrink-0 items-center gap-0.5 sm:gap-1">
            <!-- Group info (GROUP only) -->
            <button *ngIf="conv.type === 'GROUP'"
                    (click)="openGroupInfoModal(conv)"
                    title="Group info"
                    class="p-1.5 sm:p-2 rounded-lg text-gray-500 hover:bg-gray-100 hover:text-brand-600 dark:text-gray-400 dark:hover:bg-white/10 transition-colors">
              <svg width="18" height="18" viewBox="0 0 24 24" fill="none">
                <circle cx="12" cy="12" r="10" stroke="currentColor" stroke-width="1.5"/>
                <path d="M12 8v4M12 16h.01" stroke="currentColor" stroke-width="1.5" stroke-linecap="round"/>
              </svg>
            </button>
            <!-- Voice call (DM only) -->
            <button *ngIf="conv.type === 'DM'"
                    (click)="startCall(conv, 'VOICE')"
                    title="Voice call"
                    class="p-1.5 sm:p-2 rounded-lg text-gray-500 hover:bg-gray-100 hover:text-brand-600 dark:text-gray-400 dark:hover:bg-white/10 transition-colors">
              <svg width="18" height="18" viewBox="0 0 24 24" fill="none">
                <path d="M22 16.92v3a2 2 0 01-2.18 2 19.79 19.79 0 01-8.63-3.07 19.5 19.5 0 01-6-6 19.79 19.79 0 01-3.07-8.67A2 2 0 014.11 2h3a2 2 0 012 1.72c.127.96.361 1.903.7 2.81a2 2 0 01-.45 2.11L8.09 9.91a16 16 0 006 6l1.27-1.27a2 2 0 012.11-.45c.907.339 1.85.573 2.81.7A2 2 0 0122 16.92z" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
              </svg>
            </button>

            <!-- Video call (DM only) -->
            <button *ngIf="conv.type === 'DM'"
                    (click)="startCall(conv, 'VIDEO')"
                    title="Video call"
                    class="p-1.5 sm:p-2 rounded-lg text-gray-500 hover:bg-gray-100 hover:text-brand-600 dark:text-gray-400 dark:hover:bg-white/10 transition-colors">
              <svg width="18" height="18" viewBox="0 0 24 24" fill="none">
                <path fill-rule="evenodd" clip-rule="evenodd" d="M4.25 5.25C3.00736 5.25 2 6.25736 2 7.5V16.5C2 17.7426 3.00736 18.75 4.25 18.75H15.25C16.4926 18.75 17.5 17.7426 17.5 16.5V15.3957L20.1118 16.9465C20.9451 17.4412 22 16.8407 22 15.8716V8.12838C22 7.15933 20.9451 6.55882 20.1118 7.05356L17.5 8.60433V7.5C17.5 6.25736 16.4926 5.25 15.25 5.25H4.25ZM17.5 10.3488V13.6512L20.5 15.4325V8.56756L17.5 10.3488ZM3.5 7.5C3.5 7.08579 3.83579 6.75 4.25 6.75H15.25C15.6642 6.75 16 7.08579 16 7.5V16.5C16 16.9142 15.6642 17.25 15.25 17.25H4.25C3.83579 17.25 3.5 16.9142 3.5 16.5V7.5Z" fill="currentColor"/>
              </svg>
            </button>

            <!-- Mute -->
            <button (click)="muteConversation(conv)" [title]="conv.isMuted ? 'Unmute' : 'Mute'"
                    class="p-1.5 sm:p-2 rounded-lg text-gray-500 hover:bg-gray-100 hover:text-gray-800 dark:text-gray-400 dark:hover:bg-white/10 transition-colors">
              <svg *ngIf="!conv.isMuted" width="18" height="18" viewBox="0 0 24 24" fill="none">
                <path d="M11 5L6 9H2V15H6L11 19V5Z" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
                <path d="M19.07 4.93C20.9447 6.80528 21.9979 9.34836 21.9979 12C21.9979 14.6516 20.9447 17.1947 19.07 19.07M15.54 8.46C16.4774 9.39764 17.004 10.6692 17.004 11.995C17.004 13.3208 16.4774 14.5924 15.54 15.53" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
              </svg>
              <svg *ngIf="conv.isMuted" width="18" height="18" viewBox="0 0 24 24" fill="none">
                <path d="M11 5L6 9H2V15H6L11 19V5Z" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
                <path d="M23 9L17 15M17 9L23 15" stroke="currentColor" stroke-width="1.5" stroke-linecap="round"/>
              </svg>
            </button>

            <!-- Delete conversation -->
            <button (click)="openDeleteOptionsModal(conv)" title="Delete conversation"
                    class="p-1.5 sm:p-2 rounded-lg text-gray-500 hover:bg-gray-100 hover:text-error-500 dark:text-gray-400 dark:hover:bg-white/10 transition-colors">
              <svg width="18" height="18" viewBox="0 0 24 24" fill="none">
                <path d="M3 6H21M19 6L18.1991 18.0129C18.129 19.065 18.0939 19.5911 17.8667 19.99C17.6666 20.3412 17.3648 20.6235 17.0011 20.7998C16.588 21 16.0607 21 15.0062 21H8.99377C7.93927 21 7.41202 21 6.99889 20.7998C6.63517 20.6235 6.33339 20.3412 6.13332 19.99C5.90607 19.5911 5.871 19.065 5.80086 18.0129L5 6M10 11V17M14 11V17M15 6V4C15 3.44772 14.5523 3 14 3H10C9.44772 3 9 3.44772 9 4V6" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
              </svg>
            </button>
          </div>

        </div>

        <!-- ── Message Request Banner ───────────────────────────────────────── -->
        <div *ngIf="conv.messageRequest?.status === 'PENDING' && conv.messageRequest?.requestedBy !== myId"
             class="flex items-center justify-between gap-3 border-b border-amber-200 bg-amber-50 px-4 py-3 dark:border-amber-800/40 dark:bg-amber-900/20 flex-shrink-0">
          <p class="text-sm text-amber-800 dark:text-amber-300">
            <span class="font-semibold cursor-pointer hover:underline"
                  (click)="goToUserProfile(getOtherParticipant(conv), $event)">{{ getConversationName(conv) }}</span> sent you a message request.
          </p>
          <div class="flex gap-2">
            <button (click)="acceptRequest(conv)"
                    class="rounded-lg bg-brand-500 px-3 py-1.5 text-xs font-semibold text-white hover:bg-brand-600 transition-colors">
              Accept
            </button>
            <button (click)="declineRequest(conv)"
                    class="rounded-lg border border-gray-300 px-3 py-1.5 text-xs font-semibold text-gray-600 hover:bg-gray-100 dark:border-gray-600 dark:text-gray-400 dark:hover:bg-white/10 transition-colors">
              Decline
            </button>
          </div>
        </div>

        <!-- ── Message List ─────────────────────────────────────────────────── -->
        <!-- Sticky date pill wrapper -->
        <div class="relative flex flex-col flex-1 overflow-hidden">

          <!-- Floating date pill — shows only the day currently in view -->
          <div *ngIf="currentStickyDateLabel"
               class="pointer-events-none absolute left-1/2 top-2 z-20 -translate-x-1/2">
            <span class="rounded-full bg-gray-100 px-3 py-1 text-xs font-medium text-gray-500 shadow-sm dark:bg-gray-800 dark:text-gray-400">
              {{ currentStickyDateLabel }}
            </span>
          </div>

          <!-- Scroll-to-bottom button -->
          <button *ngIf="showScrollToBottom"
                  (click)="scrollToLatest()"
                  class="absolute bottom-4 left-1/2 z-20 -translate-x-1/2 flex items-center gap-1.5 rounded-full bg-white dark:bg-gray-800 border border-gray-200 dark:border-gray-700 px-3 py-1.5 text-xs font-medium text-gray-600 dark:text-gray-300 shadow-md hover:shadow-lg hover:bg-gray-50 dark:hover:bg-gray-700 transition-all">
            <svg width="12" height="12" viewBox="0 0 24 24" fill="none">
              <path d="M12 5V19M5 12L12 19L19 12" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
            </svg>
            Latest
          </button>

        <div #messageList
             (scroll)="onMessageListScroll($event)"
             class="flex-1 overflow-y-auto p-4 space-y-4 custom-scrollbar">

          <!-- Load more spinner -->
          <div *ngIf="loadingMessages$ | async" class="flex justify-center py-2">
            <div class="h-5 w-5 animate-spin rounded-full border-2 border-brand-500 border-t-transparent"></div>
          </div>

          <!-- Load older messages button -->
          <div *ngIf="(hasMoreMessages$ | async) && !(loadingMessages$ | async)"
               class="flex justify-center">
            <button (click)="chatService.loadOlderMessages()"
                    class="text-xs text-brand-500 hover:text-brand-600 font-medium py-1">
              Load older messages
            </button>
          </div>

          <!-- Messages -->
          <ng-container *ngIf="messages$ | async as messages">
            <ng-container *ngFor="let msg of messages; let i = index; trackBy: trackByMessage">

              <!-- Date boundary marker (one per day) — invisible; only used to measure
                   scroll position for the single floating pill above the list. -->
              <div *ngIf="isFirstMessageOfDay(messages, i)"
                   [attr.data-date-divider]="getDateLabel(msg.createdAt)"
                   class="h-px w-full" aria-hidden="true"></div>

              <!-- Row wrapper -->
              <div class="flex"
                   [class.justify-end]="isMine(msg)"
                   [class.justify-start]="!isMine(msg)">


              <!-- System message -->
              <div *ngIf="msg.type === 'SYSTEM'"
                   class="mx-auto text-center">
                <span class="inline-block rounded-full bg-gray-100 px-3 py-1 text-xs text-gray-500 dark:bg-white/5 dark:text-gray-400">
                  {{ msg.content }}
                </span>
              </div>

              <!-- Call record message -->
              <div *ngIf="msg.type === 'CALL'"
                   class="mx-auto flex items-center gap-2 rounded-full bg-gray-100 px-4 py-1.5 text-xs text-gray-500 dark:bg-white/5 dark:text-gray-400">
                <!-- Phone icon (voice) -->
                <svg *ngIf="!msg.content?.startsWith('📹')" width="13" height="13" viewBox="0 0 24 24" fill="none" class="shrink-0 opacity-60">
                  <path d="M22 16.92v3a2 2 0 01-2.18 2 19.79 19.79 0 01-8.63-3.07 19.5 19.5 0 01-6-6 19.79 19.79 0 01-3.07-8.67A2 2 0 014.11 2h3a2 2 0 012 1.72c.127.96.361 1.903.7 2.81a2 2 0 01-.45 2.11L8.09 9.91a16 16 0 006 6l1.27-1.27a2 2 0 012.11-.45c.907.339 1.85.573 2.81.7A2 2 0 0122 16.92z"
                        stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round"/>
                </svg>
                <!-- Video camera icon -->
                <svg *ngIf="msg.content?.startsWith('📹')" width="13" height="13" viewBox="0 0 24 24" fill="none" class="shrink-0 opacity-60">
                  <path fill-rule="evenodd" clip-rule="evenodd"
                        d="M4.25 5.25C3 5.25 2 6.26 2 7.5V16.5C2 17.74 3 18.75 4.25 18.75H15.25C16.49 18.75 17.5 17.74 17.5 16.5V15.4L20.11 16.95C20.95 17.44 22 16.84 22 15.87V8.13C22 7.16 20.95 6.56 20.11 7.05L17.5 8.6V7.5C17.5 6.26 16.49 5.25 15.25 5.25H4.25Z"
                        fill="currentColor" opacity="0.6"/>
                </svg>
                <span>{{ formatCallContent(msg.content) }}</span>
              </div>

              <!-- Regular message -->
              <div *ngIf="msg.type !== 'SYSTEM' && msg.type !== 'CALL'"
                   [id]="'msg-' + msg._id"
                   class="flex items-end gap-2 max-w-[80%] min-w-0 rounded-xl transition-all duration-300"
                   [class.flex-row-reverse]="isMine(msg)">

                <!-- Avatar (others only) -->
                <img *ngIf="!isMine(msg)"
                     [src]="msg.sender.profileImage?.urlSmall || '/images/user/user-default.svg'"
                     [alt]="msg.sender.displayName"
                     class="h-7 w-7 rounded-full object-cover flex-shrink-0 mb-1 cursor-pointer"
                     (click)="goToUserProfile(msg.sender, $event)"
                     onerror="this.src='/images/user/user-default.svg'">

                <div [class.items-end]="isMine(msg)" [class.items-start]="!isMine(msg)" class="flex flex-col gap-1 min-w-0">

                  <!-- Sender name (others only, group conversations) -->
                  <span *ngIf="!isMine(msg) && conv.type === 'GROUP'"
                        class="text-xs font-medium text-gray-500 dark:text-gray-400 px-1 cursor-pointer hover:underline"
                        (click)="goToUserProfile(msg.sender, $event)">
                    {{ msg.sender.displayName }}
                  </span>

                  <!-- Reply-to snippet -->
                  <div *ngIf="msg.replyTo"
                       (click)="scrollToMessage(msg.replyTo.messageId)"
                       class="rounded-lg border-l-2 border-brand-400 bg-gray-100 px-3 py-1.5 dark:bg-white/10 max-w-full cursor-pointer hover:bg-gray-200 dark:hover:bg-white/15 transition-colors">
                    <p class="text-[10px] font-semibold text-brand-500 dark:text-brand-400 mb-0.5">
                      {{ msg.replyTo.senderId === myId ? 'You' : (msg.replyTo.senderName || 'Unknown') }}
                    </p>
                    <ng-container *ngIf="replyGifUrl(msg, messages) as replyGif; else replySnipText">
                      <img *ngIf="autoShowMedia; else replyGifLabel"
                           [src]="replyGif" alt="GIF" loading="lazy"
                           class="mt-0.5 h-16 max-w-[120px] rounded-md object-cover">
                      <ng-template #replyGifLabel>
                        <p class="text-xs text-gray-500 dark:text-gray-400">🎞️ GIF</p>
                      </ng-template>
                    </ng-container>
                    <ng-template #replySnipText>
                      <p class="text-xs text-gray-500 dark:text-gray-400 truncate">
                        {{ isReplySnipGif(msg) ? '🎞️ GIF' : (msg.replyTo.contentSnip || (msg.replyTo.hasAttachment ? '📎 Attachment' : 'Message')) }}
                      </p>
                    </ng-template>
                  </div>

                  <!-- Bubble -->
                  <div (contextmenu)="openContextMenu($event, msg)"
                       [class.bg-brand-500]="isMine(msg)"
                       [class.text-white]="isMine(msg)"
                       [class.rounded-tr-none]="isMine(msg)"
                       [class.bg-gray-100]="!isMine(msg)"
                       [class.dark:bg-white\/5]="!isMine(msg)"
                       [class.text-gray-800]="!isMine(msg)"
                       [class.dark:text-white\/90]="!isMine(msg)"
                       [class.rounded-tl-none]="!isMine(msg)"
                       [class.opacity-60]="msg.pending || msg.failed"
                       [class.ring-2]="msg.failed"
                       [class.ring-red-400]="msg.failed"
                       class="relative rounded-2xl px-3.5 py-2.5 max-w-full min-w-0 shadow-sm cursor-pointer select-text">

                    <!-- ── Actions menu trigger — always-visible corner badge on the
                         "open" corner (opposite the tail), WhatsApp-style. Opens the
                         same menu as right-click, anchored at the click point. ── -->
                    <button *ngIf="!msg.isDeleted && !msg.pending && !msg.failed"
                            (click)="openContextMenu($event, msg); $event.stopPropagation()"
                            title="More"
                            class="absolute -top-2 z-10 flex h-5 w-5 items-center justify-center rounded-full border shadow-sm transition-colors"
                            [class.left-1]="isMine(msg)"
                            [class.right-1]="!isMine(msg)"
                            [class.bg-white]="!isMine(msg)"
                            [class.border-gray-200]="!isMine(msg)"
                            [class.text-gray-500]="!isMine(msg)"
                            [class.hover:bg-gray-100]="!isMine(msg)"
                            [class.bg-brand-600]="isMine(msg)"
                            [class.border-brand-400]="isMine(msg)"
                            [class.text-white]="isMine(msg)"
                            [class.hover:bg-brand-700]="isMine(msg)">
                      <svg width="12" height="12" viewBox="0 0 24 24" fill="none">
                        <path d="M6 9L12 15L18 9" stroke="currentColor" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round"/>
                      </svg>
                    </button>

                    <!-- Deleted message -->
                    <p *ngIf="msg.isDeleted"
                       class="text-sm italic opacity-60">
                      This message was deleted
                    </p>

                    <!-- Text content / GIF -->
                    <ng-container *ngIf="!msg.isDeleted && (msg.type === 'TEXT' || msg.type === 'GIF')">
                      <!-- GIF → render as animated image. msg.type === 'GIF' is the
                           authoritative case; isGifUrl() is kept as a fallback so
                           GIFs sent before this message type existed (stored as
                           TEXT with a Giphy URL as content) still render correctly. -->
                      <ng-container *ngIf="msg.type === 'GIF' || isGifUrl(msg.content ?? '')">
                        <img *ngIf="isMediaRevealed(msg)"
                             [src]="msg.content"
                             alt="GIF"
                             class="max-w-[240px] rounded-xl mt-1 cursor-pointer"
                             loading="lazy"
                             (load)="onMediaLoaded()"
                             (click)="$event.stopPropagation()">
                        <!-- Auto-show media is off — tap to load -->
                        <div *ngIf="!isMediaRevealed(msg)"
                             (click)="revealMedia(msg, $event)"
                             class="flex w-[180px] h-[130px] mt-1 flex-col items-center justify-center gap-1 rounded-xl bg-gray-100 dark:bg-white/10 cursor-pointer">
                          <svg width="18" height="18" viewBox="0 0 24 24" fill="none" class="text-gray-400 dark:text-gray-500">
                            <path d="M12 4V16M12 16L7 11M12 16L17 11M4 20H20" stroke="currentColor" stroke-width="1.75" stroke-linecap="round" stroke-linejoin="round"/>
                          </svg>
                          <span class="text-[11px] text-gray-500 dark:text-gray-400">Tap to view GIF</span>
                        </div>
                      </ng-container>
                      <!-- Plain text, truncated with Read more/Read less for long messages -->
                      <p *ngIf="msg.type !== 'GIF' && !isGifUrl(msg.content ?? '')"
                         class="text-sm whitespace-pre-wrap break-words [overflow-wrap:anywhere]"><ng-container
                         *ngFor="let seg of messageSegments(visibleMessageText(msg))"><a
                         *ngIf="seg.href; else plainSeg" [href]="seg.href" target="_blank" rel="noopener noreferrer nofollow"
                         (click)="$event.stopPropagation()" class="underline underline-offset-2 hover:opacity-80">{{ seg.text }}</a><ng-template
                         #plainSeg>{{ seg.text }}</ng-template></ng-container><span
                         *ngIf="(msg.content?.length ?? 0) > MESSAGE_TRUNCATE_LENGTH"
                         (click)="toggleMessageExpanded(msg._id); $event.stopPropagation()"
                         class="ml-1 font-semibold cursor-pointer hover:underline whitespace-nowrap"
                         [class.text-white]="isMine(msg)"
                         [class.text-brand-600]="!isMine(msg)">{{ isMessageExpanded(msg) ? 'Read less' : 'Read more' }}</span></p>
                      <!-- Preview card for the first link in the message, like posts get -->
                      <div *ngIf="msg.type === 'TEXT' && !msg.pending && !isGifUrl(msg.content ?? '') && hasLink(msg.content)"
                           class="w-[280px] max-w-full">
                        <app-link-preview [text]="msg.content ?? ''" [debounceMs]="0"></app-link-preview>
                      </div>
                    </ng-container>

                    <!-- Media attachments (grouped album when multiple — same message, multiple files) -->
                    <ng-container *ngIf="!msg.isDeleted && msg.attachments.length">
                      <div class="mt-1"
                           [class.grid]="msg.attachments.length > 1"
                           [class.grid-cols-2]="msg.attachments.length > 1"
                           [class.gap-1]="msg.attachments.length > 1"
                           [style.max-width.px]="msg.attachments.length > 1 ? 320 : null">
                        <div *ngFor="let att of msg.attachments" class="relative">
                          <!-- Upload progress overlay (WhatsApp-style) -->
                          <div *ngIf="msg.pending && msg.uploadProgress !== undefined && msg.uploadProgress < 100"
                               class="absolute inset-0 z-10 flex flex-col items-center justify-center rounded-xl bg-black/50 backdrop-blur-[2px]">
                            <svg class="w-8 h-8 -rotate-90" viewBox="0 0 36 36">
                              <circle cx="18" cy="18" r="14" fill="none" stroke="white" stroke-opacity="0.3" stroke-width="3"/>
                              <circle cx="18" cy="18" r="14" fill="none" stroke="white" stroke-width="3"
                                      stroke-dasharray="87.96"
                                      [attr.stroke-dashoffset]="87.96 - (87.96 * (msg.uploadProgress || 0) / 100)"
                                      stroke-linecap="round"
                                      style="transition: stroke-dashoffset 0.2s ease"/>
                            </svg>
                            <span class="mt-1 text-xs font-semibold text-white">{{ (msg.uploadProgress || 0) }}%</span>
                          </div>
                          <ng-container *ngIf="att.mimeType.startsWith('image/')">
                            <img *ngIf="isMediaRevealed(msg)"
                                 [src]="att.url"
                                 style="width: -webkit-fill-available;"
                                 class="rounded-xl object-cover cursor-pointer"
                                 [class.w-full]="msg.attachments.length > 1"
                                 [class.aspect-square]="msg.attachments.length > 1"
                                 [style.max-width.px]="msg.attachments.length <= 1 ? 220 : null"
                                 [class.opacity-40]="msg.pending"
                                 (load)="onMediaLoaded()"
                                 (click)="openMediaPreview(att, $event)">
                            <!-- Auto-show media is off — tap to load -->
                            <div *ngIf="!isMediaRevealed(msg)"
                                 (click)="revealMedia(msg, $event)"
                                 class="flex flex-col items-center justify-center gap-1 rounded-xl bg-gray-100 dark:bg-white/10 cursor-pointer"
                                 [class.w-full]="msg.attachments.length > 1"
                                 [class.aspect-square]="msg.attachments.length > 1"
                                 [style.width.px]="msg.attachments.length <= 1 ? 180 : null"
                                 [style.height.px]="msg.attachments.length <= 1 ? 130 : null">
                              <svg width="18" height="18" viewBox="0 0 24 24" fill="none" class="text-gray-400 dark:text-gray-500">
                                <path d="M12 4V16M12 16L7 11M12 16L17 11M4 20H20" stroke="currentColor" stroke-width="1.75" stroke-linecap="round" stroke-linejoin="round"/>
                              </svg>
                              <span class="text-[11px] text-gray-500 dark:text-gray-400">Tap to view</span>
                            </div>
                          </ng-container>
                          <div *ngIf="att.mimeType.startsWith('video/') && isMediaRevealed(msg)"
                               class="relative"
                               [class.w-full]="msg.attachments.length > 1"
                               [style.max-width.px]="msg.attachments.length <= 1 ? 240 : null">
                            <video [appLazyMedia]="att.url"
                                   controls
                                   (loadedmetadata)="onMediaLoaded()"
                                   class="w-full rounded-xl"
                                   [class.aspect-square]="msg.attachments.length > 1"
                                   [class.object-cover]="msg.attachments.length > 1"></video>
                            <button (click)="openMediaPreview(att, $event)"
                                    class="absolute top-2 right-2 flex h-7 w-7 items-center justify-center rounded-full bg-black/50 text-white hover:bg-black/70 transition-colors">
                              <svg width="13" height="13" viewBox="0 0 24 24" fill="none">
                                <path d="M8 3H5C4.46957 3 3.96086 3.21071 3.58579 3.58579C3.21071 3.96086 3 4.46957 3 5V8M21 8V5C21 4.46957 20.7893 3.96086 20.4142 3.58579C20.0391 3.21071 19.5304 3 19 3H16M16 21H19C19.5304 21 20.0391 20.7893 20.4142 20.4142C20.7893 20.0391 21 19.5304 21 19V16M3 16V19C3 19.5304 3.21071 20.0391 3.58579 20.4142C3.96086 20.7893 4.46957 21 5 21H8" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
                              </svg>
                            </button>
                          </div>
                          <!-- Auto-show media is off — tap to load -->
                          <div *ngIf="att.mimeType.startsWith('video/') && !isMediaRevealed(msg)"
                               (click)="revealMedia(msg, $event)"
                               class="flex flex-col items-center justify-center gap-1 rounded-xl bg-gray-100 dark:bg-white/10 cursor-pointer"
                               [class.w-full]="msg.attachments.length > 1"
                               [class.aspect-square]="msg.attachments.length > 1"
                               [style.width.px]="msg.attachments.length <= 1 ? 200 : null"
                               [style.height.px]="msg.attachments.length <= 1 ? 130 : null">
                            <svg width="18" height="18" viewBox="0 0 24 24" fill="none" class="text-gray-400 dark:text-gray-500">
                              <path d="M12 4V16M12 16L7 11M12 16L17 11M4 20H20" stroke="currentColor" stroke-width="1.75" stroke-linecap="round" stroke-linejoin="round"/>
                            </svg>
                            <span class="text-[11px] text-gray-500 dark:text-gray-400">Tap to view video</span>
                          </div>
                          <div *ngIf="att.mimeType.startsWith('audio/')" class="relative w-full mt-1">
                            <audio [appLazyMedia]="att.url"
                                   controls
                                   class="w-full"></audio>
                          </div>
                          <a *ngIf="!att.mimeType.startsWith('image/') && !att.mimeType.startsWith('video/') && !att.mimeType.startsWith('audio/')"
                             [href]="att.url" [download]="att.fileName" target="_blank"
                             class="flex items-center gap-2 rounded-lg border border-current/20 px-3 py-2 text-sm hover:bg-white/10 transition-colors">
                            <svg width="14" height="14" viewBox="0 0 24 24" fill="none"><path d="M13 2H6C5.46957 2 4.96086 2.21071 4.58579 2.58579C4.21071 2.96086 4 3.46957 4 4V20C4 20.5304 4.21071 21.0391 4.58579 21.4142C4.96086 21.7893 5.46957 22 6 22H18C18.5304 22 19.0391 21.7893 19.4142 21.4142C19.7893 21.0391 20 20.5304 20 20V9L13 2Z" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/></svg>
                            {{ att.fileName || 'Download file' }}
                          </a>
                        </div>
                      </div>
                    </ng-container>

                    <!-- Pending indicator / upload progress for non-image files -->
                    <ng-container *ngIf="msg.pending">
                      <!-- For file/audio/video types show inline progress text -->
                      <div *ngIf="msg.uploadProgress !== undefined && msg.type !== 'IMAGE'"
                           class="flex items-center gap-1.5 mt-1 text-xs opacity-70">
                        <svg class="w-3 h-3 -rotate-90 shrink-0" viewBox="0 0 36 36">
                          <circle cx="18" cy="18" r="14" fill="none" stroke="currentColor" stroke-opacity="0.3" stroke-width="4"/>
                          <circle cx="18" cy="18" r="14" fill="none" stroke="currentColor" stroke-width="4"
                                  stroke-dasharray="87.96"
                                  [attr.stroke-dashoffset]="87.96 - (87.96 * (msg.uploadProgress || 0) / 100)"
                                  stroke-linecap="round"
                                  style="transition: stroke-dashoffset 0.2s ease"/>
                        </svg>
                        <span>{{ (msg.uploadProgress || 0) }}%</span>
                      </div>
                      <!-- Sending dot for text messages -->
                      <svg *ngIf="msg.uploadProgress === undefined"
                           class="absolute -bottom-0.5 right-1 h-3 w-3 opacity-50"
                           viewBox="0 0 24 24" fill="currentColor">
                        <circle cx="12" cy="12" r="10"/>
                      </svg>
                    </ng-container>
                  </div>

                  <!-- Timestamp + read receipts -->
                  <div class="flex items-center gap-1 px-1"
                       [class.flex-row-reverse]="!isMine(msg)">
                    <span class="text-[10px] text-gray-400 dark:text-gray-500">
                      {{ formatFullTime(msg.createdAt) }}
                    </span>
                    <span *ngIf="msg.isEdited" class="text-[10px] text-gray-400">(edited)</span>
                    <!-- Send was rejected / never confirmed — say so instead of
                         leaving a faded "sending" bubble forever. -->
                    <span *ngIf="msg.failed" class="text-[10px] font-medium text-red-500"
                          [title]="msg.failedReason || 'Not sent'">
                      Not sent ·
                      <button type="button" (click)="retryMessage(msg, $event)" class="underline hover:text-red-600">Retry</button>
                    </span>
                    <!-- Read ticks (mine only) -->
                    <ng-container *ngIf="isMine(msg) && !msg.pending && !msg.failed">
                      <svg *ngIf="getReadCount(msg) > 0" width="14" height="14" viewBox="0 0 24 24" fill="none" class="text-brand-400">
                        <path d="M1.5 12.5L6 17L12 9M7 12.5L11.5 17L20 7" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
                      </svg>
                      <svg *ngIf="getReadCount(msg) === 0" width="14" height="14" viewBox="0 0 24 24" fill="none" class="text-gray-400">
                        <path d="M5 12L9.5 16.5L19 7" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
                      </svg>
                    </ng-container>
                  </div>
                </div>
              </div>
            
              </div><!-- /row wrapper -->

            </ng-container>
          </ng-container>

          <!-- Typing indicator -->
          <ng-container *ngIf="typingUsers$ | async as typingMap">
            <div *ngIf="getTypingText(typingMap, conv._id)"
                 class="flex items-center gap-2">
              <div class="flex gap-1 rounded-2xl rounded-tl-none bg-gray-100 px-3.5 py-2.5 dark:bg-white/5">
                <span class="flex gap-1 items-center">
                  <span class="h-1.5 w-1.5 rounded-full bg-gray-400 animate-bounce [animation-delay:-0.3s]"></span>
                  <span class="h-1.5 w-1.5 rounded-full bg-gray-400 animate-bounce [animation-delay:-0.15s]"></span>
                  <span class="h-1.5 w-1.5 rounded-full bg-gray-400 animate-bounce"></span>
                </span>
              </div>
              <span class="text-xs text-gray-400 dark:text-gray-500">
                {{ getTypingText(typingMap, conv._id) }}
              </span>
            </div>
          </ng-container>
        </div><!-- /message scroll div -->
        </div><!-- /sticky date wrapper -->

        <!-- ── Reply Preview ────────────────────────────────────────────────── -->
        <div *ngIf="replyingTo"
             class="flex items-center gap-3 border-t border-gray-200 bg-gray-50 px-4 py-2 dark:border-gray-700 dark:bg-gray-800/50 flex-shrink-0">
          <div class="flex-1 border-l-2 border-brand-400 pl-3 min-w-0">
            <p class="text-xs font-medium text-brand-600 dark:text-brand-400">
              Replying to {{ isMine(replyingTo) ? 'yourself' : replyingTo.sender.displayName }}
            </p>
            <ng-container *ngIf="replyingTo.type === 'GIF' || isGifUrl(replyingTo.content ?? ''); else replyingToText">
              <img *ngIf="autoShowMedia; else replyingToGifLabel"
                   [src]="replyingTo.content" alt="GIF"
                   class="mt-0.5 h-12 max-w-[100px] rounded-md object-cover">
              <ng-template #replyingToGifLabel>
                <p class="text-xs text-gray-500 dark:text-gray-400">🎞️ GIF</p>
              </ng-template>
            </ng-container>
            <ng-template #replyingToText>
              <p class="text-xs text-gray-500 dark:text-gray-400 truncate">{{ replyingTo.content }}</p>
            </ng-template>
          </div>
          <button (click)="cancelReply()" class="text-gray-400 hover:text-gray-600 dark:hover:text-gray-200">
            <svg width="16" height="16" viewBox="0 0 24 24" fill="none">
              <path d="M18 6L6 18M6 6L18 18" stroke="currentColor" stroke-width="2" stroke-linecap="round"/>
            </svg>
          </button>
        </div>

        <!-- ── Edit Mode Banner ─────────────────────────────────────────────── -->
        <div *ngIf="editingMessageId"
             class="flex items-center gap-3 border-t border-gray-200 bg-amber-50 px-4 py-2 dark:border-gray-700 dark:bg-amber-900/20 flex-shrink-0">
          <svg class="text-amber-500 flex-shrink-0" width="16" height="16" viewBox="0 0 24 24" fill="none">
            <path d="M11 4H4C3.46957 4 2.96086 4.21071 2.58579 4.58579C2.21071 4.96086 2 5.46957 2 6V20C2 20.5304 2.21071 21.0391 2.58579 21.4142C2.96086 21.7893 3.46957 22 4 22H18C18.5304 22 19.0391 21.7893 19.4142 21.4142C19.7893 21.0391 20 20.5304 20 20V13M18.5 2.5C18.8978 2.10217 19.4374 1.87868 20 1.87868C20.5626 1.87868 21.1022 2.10217 21.5 2.5C21.8978 2.89782 22.1213 3.43739 22.1213 4C22.1213 4.56261 21.8978 5.10218 21.5 5.5L12 15L8 16L9 12L18.5 2.5Z" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
          </svg>
          <p class="text-xs text-amber-700 dark:text-amber-300 flex-1">Editing message</p>
          <button (click)="cancelEdit()" class="text-xs text-gray-500 hover:text-gray-700 dark:hover:text-gray-300">Cancel</button>
        </div>

        <!-- ── Message Input ────────────────────────────────────────────────── -->
        <!-- Media preview strip (up to MAX_MEDIA_UPLOAD_COUNT files staged at once) -->
        <div *ngIf="selectedMediaItems.length"
             class="flex flex-col gap-2 border-t border-gray-200 bg-gray-50 px-4 py-2 dark:border-gray-700 dark:bg-gray-800/50 flex-shrink-0">
          <div class="flex items-center gap-2 overflow-x-auto custom-scrollbar">
            <div *ngFor="let item of selectedMediaItems; let i = index" class="relative flex-shrink-0">
              <img *ngIf="item.preview && item.type === 'IMAGE'"
                   [src]="item.preview" class="h-14 w-14 rounded-lg object-cover">
              <video *ngIf="item.preview && item.type === 'VIDEO'"
                     [src]="item.preview" class="h-14 w-24 rounded-lg object-cover"></video>
              <div *ngIf="!item.preview"
                   class="flex h-14 items-center gap-2 rounded-lg bg-gray-100 px-3 dark:bg-white/10">
                <svg width="16" height="16" viewBox="0 0 24 24" fill="none"><path d="M13 2H6C5.46957 2 4.96086 2.21071 4.58579 2.58579C4.21071 2.96086 4 3.46957 4 4V20C4 20.5304 4.21071 21.0391 4.58579 21.4142C4.96086 21.7893 5.46957 22 6 22H18C18.5304 22 19.0391 21.7893 19.4142 21.4142C19.7893 21.0391 20 20.5304 20 20V9L13 2Z" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/></svg>
                <span class="text-xs text-gray-600 dark:text-gray-300 truncate max-w-[80px]">{{ item.file.name }}</span>
              </div>
              <button (click)="removeSelectedMediaItem(i)"
                      class="absolute -top-1.5 -right-1.5 flex h-4 w-4 items-center justify-center rounded-full bg-gray-700 text-white hover:bg-gray-900">
                <svg width="10" height="10" viewBox="0 0 24 24" fill="none"><path d="M18 6L6 18M6 6L18 18" stroke="currentColor" stroke-width="3" stroke-linecap="round"/></svg>
              </button>
            </div>
          </div>
          <div class="flex items-center justify-between gap-2">
            <p *ngIf="mediaSelectError" class="text-[11px] text-red-500">{{ mediaSelectError }}</p>
            <p *ngIf="!mediaSelectError" class="text-[11px] text-gray-400 dark:text-gray-500">
              {{ selectedMediaItems.length }}/{{ MAX_MEDIA_UPLOAD_COUNT }} selected
            </p>
            <div class="flex items-center gap-2 ml-auto">
              <button (click)="sendMedia()"
                      class="rounded-lg bg-brand-500 px-3 py-1.5 text-xs font-semibold text-white hover:bg-brand-600">Send</button>
              <button (click)="clearSelectedMedia()" class="text-gray-400 hover:text-gray-600">
                <svg width="16" height="16" viewBox="0 0 24 24" fill="none"><path d="M18 6L6 18M6 6L18 18" stroke="currentColor" stroke-width="2" stroke-linecap="round"/></svg>
              </button>
            </div>
          </div>
        </div>

        <!-- GIF preview strip -->
        <div *ngIf="selectedGifUrl && !selectedMediaItems.length"
             class="flex items-center gap-3 border-t border-gray-200 bg-gray-50 px-4 py-2 dark:border-gray-700 dark:bg-gray-800/50 flex-shrink-0">
          <img [src]="selectedGifUrl" alt="Selected GIF"
               class="h-16 rounded-lg object-cover max-w-[140px]">
          <div class="flex-1"></div>
          <button (click)="clearSelectedGif()" class="text-gray-400 hover:text-gray-600">
            <svg width="16" height="16" viewBox="0 0 24 24" fill="none"><path d="M18 6L6 18M6 6L18 18" stroke="currentColor" stroke-width="2" stroke-linecap="round"/></svg>
          </button>
        </div>

        <!-- Group restriction banner -->
        <div *ngIf="conv.type === 'GROUP' && !isCanSendMessage(conv)"
             class="flex items-center gap-2 border-t border-amber-200 bg-amber-50 px-4 py-2 dark:border-amber-800/40 dark:bg-amber-900/20 flex-shrink-0">
          <svg class="text-amber-500 flex-shrink-0" width="16" height="16" viewBox="0 0 24 24" fill="none">
            <path d="M12 22C17.5228 22 22 17.5228 22 12C22 6.47715 17.5228 2 12 2C6.47715 2 2 6.47715 2 12C2 17.5228 6.47715 22 12 22Z" stroke="currentColor" stroke-width="1.5"/>
            <path d="M12 8V12M12 16h.01" stroke="currentColor" stroke-width="1.5" stroke-linecap="round"/>
          </svg>
          <p class="text-xs text-amber-700 dark:text-amber-300">
            {{ conv.onlyAdminsCanSend ? 'Only admins can send messages' : 'You have been muted by an admin' }}
          </p>
        </div>

        <!-- DM blocked banner -->
        <div *ngIf="conv.type === 'DM' && conv.isBlocked"
             class="flex items-center justify-between gap-2 border-t border-gray-200 bg-gray-50 px-4 py-2 dark:border-gray-700 dark:bg-gray-800/60 flex-shrink-0">
          <div class="flex items-center gap-2 min-w-0">
            <svg class="text-gray-400 flex-shrink-0" width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.5">
              <circle cx="12" cy="12" r="10" />
              <line x1="4.93" y1="4.93" x2="19.07" y2="19.07" />
            </svg>
            <p class="text-xs text-gray-500 dark:text-gray-400 truncate">
              {{ conv.blockedByMe ? "You blocked this contact" : "You can't message this contact" }}
            </p>
          </div>
          <button *ngIf="conv.blockedByMe" (click)="unblockConversationContact(conv)"
                  class="flex-shrink-0 rounded-lg border border-[#D31148] px-3 py-1 text-xs font-semibold text-[#D31148] transition hover:bg-[#FFD4E0]">
            Unblock
          </button>
        </div>

        <!-- DM not-friends banner (unfriended — read-only, past messages still visible) -->
        <div *ngIf="conv.type === 'DM' && !conv.isBlocked && !conv.messageRequest && conv.isFriend === false"
             class="flex items-center justify-between gap-2 border-t border-gray-200 bg-gray-50 px-4 py-2 dark:border-gray-700 dark:bg-gray-800/60 flex-shrink-0">
          <div class="flex items-center gap-2 min-w-0">
            <svg class="text-gray-400 flex-shrink-0" width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.5">
              <path d="M16 21v-2a4 4 0 0 0-4-4H5a4 4 0 0 0-4 4v2" stroke-linecap="round" stroke-linejoin="round"/>
              <circle cx="8.5" cy="7" r="4"/>
              <line x1="20" y1="8" x2="20" y2="14" stroke-linecap="round"/>
              <line x1="23" y1="11" x2="17" y2="11" stroke-linecap="round"/>
            </svg>
            <p class="text-xs text-gray-500 dark:text-gray-400 truncate">
              You are not friends with this user
            </p>
          </div>
          <button (click)="addFriendFromChat(conv)"
                  class="flex-shrink-0 rounded-lg border border-[#D31148] px-3 py-1 text-xs font-semibold text-[#D31148] transition hover:bg-[#FFD4E0]">
            Add Friend
          </button>
        </div>

        <div class="flex-shrink-0 border-t border-gray-200 p-3 dark:border-gray-800"
             [class.opacity-50]="(conv.messageRequest?.status === 'PENDING' && conv.messageRequest?.requestedBy !== myId) || !isCanSendMessage(conv)"
             [class.pointer-events-none]="(conv.messageRequest?.status === 'PENDING' && conv.messageRequest?.requestedBy !== myId) || !isCanSendMessage(conv)">
          <div class="flex items-end gap-2">
            <!-- Mobile ("+") attach menu — below `sm` the file/GIF/emoji buttons
                 below would otherwise eat ~140px off a ~360px-wide screen, leaving
                 almost nothing for the message box itself. Collapsed here into one
                 button whose popup surfaces the same three actions, so the
                 textarea gets that width back. -->
            <div class="relative flex-shrink-0 sm:hidden">
              <div *ngIf="showMobileAttachMenu"
                   class="absolute bottom-full left-0 mb-2 w-48 rounded-2xl border border-gray-200 bg-white shadow-xl z-[500] overflow-hidden p-1.5 dark:bg-gray-900 dark:border-gray-700"
                   (click)="$event.stopPropagation()">
                <button (click)="chatFileInput.click(); showMobileAttachMenu = false"
                        class="flex w-full items-center gap-3 rounded-xl px-3 py-2.5 text-sm text-gray-700 hover:bg-gray-100 dark:text-gray-200 dark:hover:bg-white/10 transition-colors">
                  <svg width="18" height="18" viewBox="0 0 24 24" fill="none" class="flex-shrink-0 text-gray-500 dark:text-gray-400">
                    <path d="M21 15V19C21 19.5304 20.7893 20.0391 20.4142 20.4142C20.0391 20.7893 19.5304 21 19 21H5C4.46957 21 3.96086 20.7893 3.58579 20.4142C3.21071 20.0391 3 19.5304 3 19V15M17 8L12 3L7 8M12 3V15" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
                  </svg>
                  Photo &amp; File
                </button>
                <button (click)="toggleGifPicker($event)"
                        class="flex w-full items-center gap-3 rounded-xl px-3 py-2.5 text-sm text-gray-700 hover:bg-gray-100 dark:text-gray-200 dark:hover:bg-white/10 transition-colors">
                  <span class="flex h-[18px] w-[18px] flex-shrink-0 items-center justify-center text-[10px] font-black leading-none text-gray-500 dark:text-gray-400">GIF</span>
                  GIF
                </button>
                <button (click)="toggleEmojiPicker($event)"
                        class="flex w-full items-center gap-3 rounded-xl px-3 py-2.5 text-sm text-gray-700 hover:bg-gray-100 dark:text-gray-200 dark:hover:bg-white/10 transition-colors">
                  <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" class="flex-shrink-0 text-gray-500 dark:text-gray-400">
                    <circle cx="12" cy="12" r="10"/>
                    <path d="M8 14s1.5 2 4 2 4-2 4-2"/>
                    <line x1="9" y1="9" x2="9.01" y2="9"/>
                    <line x1="15" y1="9" x2="15.01" y2="9"/>
                  </svg>
                  Emoji
                </button>
              </div>

              <button (click)="toggleMobileAttachMenu($event)"
                      [class.text-brand-500]="showMobileAttachMenu"
                      [class.rotate-45]="showMobileAttachMenu"
                      class="flex h-10 w-10 items-center justify-center rounded-xl border border-gray-200 text-gray-500 hover:bg-gray-100 dark:border-gray-700 dark:text-gray-400 dark:hover:bg-white/10 transition-all"
                      aria-label="Add photo, file, GIF or emoji" title="Add">
                <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
                  <line x1="12" y1="5" x2="12" y2="19"/>
                  <line x1="5" y1="12" x2="19" y2="12"/>
                </svg>
              </button>
            </div>

            <!-- Desktop / tablet — file, GIF, and emoji keep their own buttons;
                 there's room for them from `sm` up. -->
            <div class="hidden sm:contents">
              <!-- Media upload button -->
              <label class="flex h-10 w-10 flex-shrink-0 items-center justify-center rounded-xl border border-gray-200 text-gray-500 hover:bg-gray-100 dark:border-gray-700 dark:text-gray-400 dark:hover:bg-white/10 cursor-pointer transition-colors">
                <!-- #chatFileInput: also the target of the mobile "+" menu's
                     "Photo & File" button above. A hidden file input can still be
                     triggered via .click() while its ancestor is `display:none`,
                     so one input serves both entry points instead of duplicating
                     it (and its accept/multiple rules) a second time. -->
                <input #chatFileInput type="file"
                       accept="image/*,.jfif,.heic,.heif,video/*,audio/*,.pdf,.doc,.docx"
                       multiple
                       (change)="onFileSelected($event)"
                       class="hidden">
                <svg width="18" height="18" viewBox="0 0 24 24" fill="none">
                  <path d="M21 15V19C21 19.5304 20.7893 20.0391 20.4142 20.4142C20.0391 20.7893 19.5304 21 19 21H5C4.46957 21 3.96086 20.7893 3.58579 20.4142C3.21071 20.0391 3 19.5304 3 19V15M17 8L12 3L7 8M12 3V15" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
                </svg>
              </label>

              <!-- GIF button -->
              <div class="relative flex-shrink-0">
                <!-- GIF Picker Panel -->
                <div *ngIf="showGifPicker"
                     class="absolute bottom-full left-0 mb-2 w-72 rounded-2xl border border-gray-200 bg-white shadow-xl z-[500] overflow-hidden dark:bg-gray-900 dark:border-gray-700"
                     (click)="$event.stopPropagation()">
                  <div class="flex items-center gap-2 p-3 border-b border-gray-100 dark:border-gray-800">
                    <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="#9ca3af" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
                      <circle cx="11" cy="11" r="8"/><line x1="21" y1="21" x2="16.65" y2="16.65"/>
                    </svg>
                    <input [(ngModel)]="gifSearchQuery"
                           type="text"
                           placeholder="Search GIFs…"
                           (keyup)="onGifSearchKey($event)"
                           class="flex-1 text-sm outline-none text-gray-700 placeholder-gray-400 bg-transparent dark:text-white">
                    <button (click)="searchGifs()" class="text-xs font-bold text-brand-500 hover:underline">Search</button>
                  </div>
                  <div class="p-2 max-h-52 overflow-y-auto">
                    <div *ngIf="gifLoading" class="flex items-center justify-center py-8">
                      <div class="w-6 h-6 border-2 border-brand-500 border-t-transparent rounded-full animate-spin"></div>
                    </div>
                    <div *ngIf="!gifLoading && gifResults.length === 0" class="py-6 text-center text-sm text-gray-400">
                      No GIFs found.
                    </div>
                    <div *ngIf="!gifLoading && gifResults.length > 0" class="grid grid-cols-3 gap-1">
                      <button *ngFor="let gif of gifResults"
                              (click)="selectGif(gif)"
                              class="rounded-lg overflow-hidden hover:ring-2 hover:ring-brand-500 transition-all aspect-video">
                        <img [src]="gif.preview" alt="GIF" class="w-full h-full object-cover" loading="lazy">
                      </button>
                    </div>
                    <p *ngIf="gifResults.length > 0" class="text-[10px] text-gray-400 text-center pt-2">Powered by GIPHY</p>
                  </div>
                </div>

                <button (click)="toggleGifPicker($event)"
                        [class.text-brand-500]="showGifPicker"
                        class="flex h-10 w-10 items-center justify-center rounded-xl border border-gray-200 text-xs font-black text-gray-500 hover:bg-gray-100 dark:border-gray-700 dark:text-gray-400 dark:hover:bg-white/10 transition-colors leading-none tracking-tight">
                  GIF
                </button>
              </div>

              <!-- Emoji button + picker -->
              <div class="relative flex-shrink-0">
                <!-- Emoji picker panel -->
                <div *ngIf="showEmojiPicker"
                     class="absolute bottom-full left-0 mb-2 w-72 rounded-2xl border border-gray-200 bg-white shadow-xl z-[500] overflow-hidden dark:bg-gray-900 dark:border-gray-700"
                     (click)="$event.stopPropagation()">
                  <!-- Category tabs -->
                  <div class="flex border-b border-gray-100 dark:border-gray-800 px-2 pt-2 gap-1">
                    <button *ngFor="let cat of EMOJI_CATEGORIES; let i = index"
                            (click)="setEmojiTab(i)"
                            class="px-3 py-1.5 rounded-lg text-xs font-semibold transition-colors"
                            [class.bg-brand-500]="activeEmojiTab === i"
                            [class.text-white]="activeEmojiTab === i"
                            [class.text-gray-500]="activeEmojiTab !== i"
                            [class.hover:bg-gray-100]="activeEmojiTab !== i">
                      {{ cat.label }}
                    </button>
                  </div>
                  <!-- Emoji grid -->
                  <div class="flex flex-wrap gap-0.5 p-3 max-h-44 overflow-y-auto">
                    <button *ngFor="let emoji of EMOJI_CATEGORIES[activeEmojiTab].emojis"
                            (click)="pickEmoji(emoji)"
                            class="text-xl w-9 h-9 flex items-center justify-center rounded-lg hover:bg-gray-100 dark:hover:bg-white/10 hover:scale-110 transition-all">
                      {{ emoji }}
                    </button>
                  </div>
                </div>

                <button (click)="toggleEmojiPicker($event)"
                        [class.text-brand-500]="showEmojiPicker"
                        class="flex h-10 w-10 items-center justify-center rounded-xl border border-gray-200 text-gray-500 hover:bg-gray-100 dark:border-gray-700 dark:text-gray-400 dark:hover:bg-white/10 transition-colors"
                        title="Emoji">
                  <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
                    <circle cx="12" cy="12" r="10"/>
                    <path d="M8 14s1.5 2 4 2 4-2 4-2"/>
                    <line x1="9" y1="9" x2="9.01" y2="9"/>
                    <line x1="15" y1="9" x2="15.01" y2="9"/>
                  </svg>
                </button>
              </div>
            </div>

            <!-- Mobile also gets the GIF/emoji panels themselves — opened from the
                 "+" menu above, they render here so they anchor to the textarea
                 row rather than the (hidden-on-mobile) desktop buttons. -->
            <div class="relative flex-shrink-0 w-0 sm:hidden">
              <div *ngIf="showGifPicker"
                   class="absolute bottom-full left-0 mb-2 w-72 max-w-[calc(100vw-2rem)] rounded-2xl border border-gray-200 bg-white shadow-xl z-[500] overflow-hidden dark:bg-gray-900 dark:border-gray-700"
                   (click)="$event.stopPropagation()">
                <div class="flex items-center gap-2 p-3 border-b border-gray-100 dark:border-gray-800">
                  <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="#9ca3af" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
                    <circle cx="11" cy="11" r="8"/><line x1="21" y1="21" x2="16.65" y2="16.65"/>
                  </svg>
                  <input [(ngModel)]="gifSearchQuery"
                         type="text"
                         placeholder="Search GIFs…"
                         (keyup)="onGifSearchKey($event)"
                         class="flex-1 text-sm outline-none text-gray-700 placeholder-gray-400 bg-transparent dark:text-white">
                  <button (click)="searchGifs()" class="text-xs font-bold text-brand-500 hover:underline">Search</button>
                </div>
                <div class="p-2 max-h-52 overflow-y-auto">
                  <div *ngIf="gifLoading" class="flex items-center justify-center py-8">
                    <div class="w-6 h-6 border-2 border-brand-500 border-t-transparent rounded-full animate-spin"></div>
                  </div>
                  <div *ngIf="!gifLoading && gifResults.length === 0" class="py-6 text-center text-sm text-gray-400">
                    No GIFs found.
                  </div>
                  <div *ngIf="!gifLoading && gifResults.length > 0" class="grid grid-cols-3 gap-1">
                    <button *ngFor="let gif of gifResults"
                            (click)="selectGif(gif)"
                            class="rounded-lg overflow-hidden hover:ring-2 hover:ring-brand-500 transition-all aspect-video">
                      <img [src]="gif.preview" alt="GIF" class="w-full h-full object-cover" loading="lazy">
                    </button>
                  </div>
                  <p *ngIf="gifResults.length > 0" class="text-[10px] text-gray-400 text-center pt-2">Powered by GIPHY</p>
                </div>
              </div>

              <div *ngIf="showEmojiPicker"
                   class="absolute bottom-full left-0 mb-2 w-72 max-w-[calc(100vw-2rem)] rounded-2xl border border-gray-200 bg-white shadow-xl z-[500] overflow-hidden dark:bg-gray-900 dark:border-gray-700"
                   (click)="$event.stopPropagation()">
                <div class="flex border-b border-gray-100 dark:border-gray-800 px-2 pt-2 gap-1">
                  <button *ngFor="let cat of EMOJI_CATEGORIES; let i = index"
                          (click)="setEmojiTab(i)"
                          class="px-3 py-1.5 rounded-lg text-xs font-semibold transition-colors"
                          [class.bg-brand-500]="activeEmojiTab === i"
                          [class.text-white]="activeEmojiTab === i"
                          [class.text-gray-500]="activeEmojiTab !== i"
                          [class.hover:bg-gray-100]="activeEmojiTab !== i">
                    {{ cat.label }}
                  </button>
                </div>
                <div class="flex flex-wrap gap-0.5 p-3 max-h-44 overflow-y-auto">
                  <button *ngFor="let emoji of EMOJI_CATEGORIES[activeEmojiTab].emojis"
                          (click)="pickEmoji(emoji)"
                          class="text-xl w-9 h-9 flex items-center justify-center rounded-lg hover:bg-gray-100 dark:hover:bg-white/10 hover:scale-110 transition-all">
                    {{ emoji }}
                  </button>
                </div>
              </div>
            </div>

            <textarea #messageInput
                      [(ngModel)]="messageText"
                      (input)="onInput($event)"
                      (keydown)="onKeyDown($event)"
                      placeholder="Type a message…"
                      rows="1"
                      class="flex-1 resize-none rounded-xl border border-gray-200 bg-gray-50 px-4 py-2.5 text-sm text-gray-800 placeholder:text-gray-400 focus:border-brand-300 focus:outline-none focus:ring-2 focus:ring-brand-500/10 dark:border-gray-700 dark:bg-gray-800 dark:text-white/90 dark:placeholder:text-white/30 max-h-32 overflow-y-auto"
                      style="field-sizing: content">
            </textarea>
            <button (click)="sendMessage()"
                    [disabled]="!messageText.trim() && !selectedGifUrl"
                    class="flex h-10 w-10 flex-shrink-0 items-center justify-center rounded-xl bg-brand-500 text-white transition-colors hover:bg-brand-600 disabled:opacity-40 disabled:cursor-not-allowed">
              <svg width="18" height="18" viewBox="0 0 20 20" fill="none">
                <path fill-rule="evenodd" clip-rule="evenodd" d="M4.98481 2.44399C3.11333 1.57147 1.15325 3.46979 1.96543 5.36824L3.82086 9.70527C3.90146 9.89367 3.90146 10.1069 3.82086 10.2953L1.96543 14.6323C1.15326 16.5307 3.11332 18.4291 4.98481 17.5565L16.8184 12.0395C18.5508 11.2319 18.5508 8.76865 16.8184 7.961L4.98481 2.44399Z" fill="white"/>
              </svg>
            </button>
          </div>
        </div>

      </ng-container>

      <!-- No conversation selected -->
      <ng-template #noConversation>
        <div class="hidden xl:flex flex-col flex-1 items-center justify-center gap-4 text-center p-8">
          <div class="flex h-20 w-20 items-center justify-center rounded-full bg-gray-100 dark:bg-white/5">
            <svg class="text-gray-400 dark:text-gray-500" width="40" height="40" viewBox="0 0 24 24" fill="none">
              <path d="M21 15C21 15.5304 20.7893 16.0391 20.4142 16.4142C20.0391 16.7893 19.5304 17 19 17H7L3 21V5C3 4.46957 3.21071 3.96086 3.58579 3.58579C3.96086 3.21071 4.46957 3 5 3H19C19.5304 3 20.0391 3.21071 20.4142 3.58579C20.7893 3.96086 21 4.46957 21 5V15Z" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
            </svg>
          </div>
          <div>
            <h4 class="text-base font-semibold text-gray-800 dark:text-white/90">Your messages</h4>
            <p class="mt-1 text-sm text-gray-500 dark:text-gray-400">Select a conversation to start chatting</p>
          </div>
        </div>
      </ng-template>
    </div>
    <!-- END CHAT WINDOW -->

  </div>
</div>

<!-- ═══════════════════════════════════════════════════════════════════════════
     CONTEXT MENU (right-click on message)
═══════════════════════════════════════════════════════════════════════════ -->
<div *ngIf="contextMenuMessage"
     (click)="closeContextMenu()"
     class="fixed inset-0 z-50">
  <div class="absolute rounded-xl border border-gray-200 bg-white p-1.5 shadow-lg dark:border-gray-700 dark:bg-gray-800 min-w-[150px]"
       [style.left.px]="contextMenuX"
       [style.top.px]="contextMenuY">

    <button (click)="setReply(contextMenuMessage!)"
            class="flex w-full items-center gap-2 rounded-lg px-3 py-2 text-sm text-gray-700 hover:bg-gray-100 dark:text-gray-300 dark:hover:bg-white/10">
      <svg width="14" height="14" viewBox="0 0 24 24" fill="none">
        <path d="M9 17L4 12M4 12L9 7M4 12H16C18.2091 12 20 13.7909 20 16V19" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
      </svg>
      Reply
    </button>

    <ng-container *ngIf="isMine(contextMenuMessage!) && !contextMenuMessage!.isDeleted">
      <button *ngIf="canEditMessage(contextMenuMessage!)"
              (click)="startEdit(contextMenuMessage!)"
              class="flex w-full items-center gap-2 rounded-lg px-3 py-2 text-sm text-gray-700 hover:bg-gray-100 dark:text-gray-300 dark:hover:bg-white/10">
        <svg width="14" height="14" viewBox="0 0 24 24" fill="none">
          <path d="M11 4H4C3.46957 4 2.96086 4.21071 2.58579 4.58579C2.21071 4.96086 2 5.46957 2 6V20C2 20.5304 2.21071 21.0391 2.58579 21.4142C2.96086 21.7893 3.46957 22 4 22H18C18.5304 22 19.0391 21.7893 19.4142 21.4142C19.7893 21.0391 20 20.5304 20 20V13M18.5 2.5C19.3284 1.67157 20.6716 1.67157 21.5 2.5C22.3284 3.32843 22.3284 4.67157 21.5 5.5L12 15L8 16L9 12L18.5 2.5Z" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
        </svg>
        Edit
      </button>

      <button *ngIf="canDeleteForEveryone(contextMenuMessage!)"
              (click)="deleteForEveryone(contextMenuMessage!)"
              class="flex w-full items-center gap-2 rounded-lg px-3 py-2 text-sm text-error-600 hover:bg-error-50 dark:text-error-400 dark:hover:bg-error-900/20">
        <svg width="14" height="14" viewBox="0 0 24 24" fill="none">
          <path d="M3 6H21M19 6L18.2 18.01C18.13 19.065 18.095 19.591 17.867 19.99C17.667 20.341 17.365 20.623 17.001 20.8C16.588 21 16.061 21 15.006 21H8.994C7.939 21 7.412 21 6.999 20.8C6.635 20.623 6.333 20.341 6.133 19.99C5.906 19.591 5.871 19.065 5.8 18.01L5 6" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
        </svg>
        Delete for everyone
      </button>
    </ng-container>

    <button (click)="deleteForMe(contextMenuMessage!)"
            class="flex w-full items-center gap-2 rounded-lg px-3 py-2 text-sm text-gray-500 hover:bg-gray-100 dark:text-gray-400 dark:hover:bg-white/10">
      <svg width="14" height="14" viewBox="0 0 24 24" fill="none">
        <path d="M3 6H21M19 6L18.2 18.01C18.13 19.065 18.095 19.591 17.867 19.99C17.667 20.341 17.365 20.623 17.001 20.8C16.588 21 16.061 21 15.006 21H8.994C7.939 21 7.412 21 6.999 20.8C6.635 20.623 6.333 20.341 6.133 19.99C5.906 19.591 5.871 19.065 5.8 18.01L5 6" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
      </svg>
      Delete for me
    </button>
  </div>
</div>

<!-- ═══════════════════════════════════════════════════════════════════════════
     NEW MESSAGE MODAL  (Instagram-style friend search)
═══════════════════════════════════════════════════════════════════════════ -->
<app-modal [isOpen]="showNewMessageModal" (close)="closeNewMessageModal()" className="max-w-md">
  <div class="flex h-full flex-col overflow-hidden rounded-2xl bg-white shadow-2xl dark:bg-gray-900">

    <!-- Modal Header -->
    <div class="flex items-center justify-between border-b border-gray-100 px-5 py-4 dark:border-gray-800">
      <h3 class="text-lg font-semibold text-gray-800 dark:text-white/90">New message</h3>
      <button (click)="closeNewMessageModal()"
              class="flex h-7 w-7 items-center justify-center rounded-full text-gray-400 hover:bg-gray-100 hover:text-gray-600 dark:hover:bg-white/10">
        <svg width="16" height="16" viewBox="0 0 24 24" fill="none">
          <path d="M18 6L6 18M6 6L18 18" stroke="currentColor" stroke-width="2" stroke-linecap="round"/>
        </svg>
      </button>
    </div>

    <!-- Search input (sticky at top) -->
    <div class="flex items-center gap-2 border-b border-gray-100 px-5 py-3 dark:border-gray-800">
      <span class="text-xs font-semibold text-gray-500 dark:text-gray-400 flex-shrink-0">To:</span>

      <!-- Selected chip -->
      <div *ngIf="newMsgSelected"
           class="flex flex-shrink-0 items-center gap-1.5 rounded-full border border-brand-200 bg-brand-50 pl-1 pr-2 py-0.5 dark:border-brand-700 dark:bg-brand-900/30">
        <img [src]="newMsgSelected.profileImage?.urlSmall || '/images/user/user-default.svg'"
             class="h-5 w-5 rounded-full object-cover">
        <span class="text-xs font-semibold text-brand-700 dark:text-brand-300">
          {{ newMsgSelected.displayName }}
        </span>
        <button (click)="newMsgSelected = null; newMsgSearch = ''; onNewMsgInput()"
                class="ml-0.5 text-brand-400 hover:text-brand-600">
          <svg width="10" height="10" viewBox="0 0 24 24" fill="none">
            <path d="M18 6L6 18M6 6L18 18" stroke="currentColor" stroke-width="2.5" stroke-linecap="round"/>
          </svg>
        </button>
      </div>

      <input *ngIf="!newMsgSelected"
             type="text"
             [(ngModel)]="newMsgSearch"
             (input)="onNewMsgInput()"
             placeholder="Search friends…"
             autofocus
             class="flex-1 bg-transparent text-sm text-gray-800 placeholder:text-gray-400 focus:outline-none dark:text-white/90 dark:placeholder:text-white/30">
    </div>

    <!-- Results list -->
    <div class="max-h-72 overflow-y-auto custom-scrollbar">

      <!-- Loading -->
      <div *ngIf="newMsgLoading" class="flex justify-center py-8">
        <div class="h-5 w-5 animate-spin rounded-full border-2 border-brand-500 border-t-transparent"></div>
      </div>

      <!-- Empty -->
      <div *ngIf="!newMsgLoading && newMsgResults.length === 0"
           class="flex flex-col items-center justify-center px-4 py-10 text-center">
        <svg class="mb-2 text-gray-300 dark:text-gray-600" width="36" height="36" viewBox="0 0 24 24" fill="none">
          <path d="M17 21v-2a4 4 0 00-4-4H5a4 4 0 00-4 4v2M23 21v-2a4 4 0 00-3-3.87M16 3.13a4 4 0 010 7.75M9 11a4 4 0 100-8 4 4 0 000 8z" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
        </svg>
        <p class="text-sm font-medium text-gray-500 dark:text-gray-400">No friends found</p>
        <p class="mt-0.5 text-xs text-gray-400 dark:text-gray-500">
          {{ newMsgSearch ? 'Try a different name' : 'Add friends to start messaging' }}
        </p>
      </div>

      <!-- Friend rows -->
      <div *ngFor="let user of newMsgResults"
           (click)="selectNewMsgUser(user)"
           [class.dark:bg-brand-900\/20]="newMsgSelected?._id === user._id"
           class="flex cursor-pointer items-center gap-3 px-5 py-3 transition-colors hover:bg-gray-50 dark:hover:bg-white/[0.03]">

        <!-- Avatar -->
        <div class="relative flex-shrink-0">
          <img [src]="user.profileImage?.urlSmall || '/images/user/user-default.svg'"
               [alt]="user.displayName"
               class="h-11 w-11 rounded-full object-cover"
               onerror="this.src='/images/user/user-default.svg'">
        </div>

        <!-- Info -->
        <div class="flex-1 min-w-0">
          <p class="truncate text-sm font-semibold text-gray-800 dark:text-white/90">
            {{ user.displayName }}
          </p>
          <p class="text-xs text-gray-400 dark:text-gray-500">
            @{{ user.userName }}
          </p>
        </div>

        <!-- Selected check -->
        <div *ngIf="newMsgSelected?._id === user._id"
             class="flex h-5 w-5 flex-shrink-0 items-center justify-center rounded-full bg-brand-500">
          <svg width="10" height="10" viewBox="0 0 24 24" fill="none">
            <path d="M5 13L9 17L19 7" stroke="white" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round"/>
          </svg>
        </div>
      </div>
    </div>

    <!-- Footer: Chat button -->
    <div class="border-t border-gray-100 px-5 py-4 dark:border-gray-800">
      <button (click)="startNewDm()"
              [disabled]="!newMsgSelected"
              class="w-full rounded-xl bg-brand-500 py-2.5 text-sm font-semibold text-white transition-colors hover:bg-brand-600 disabled:cursor-not-allowed disabled:opacity-40">
        Chat
      </button>
    </div>
  </div>
</app-modal>

<!-- ═══════════════════════════════════════════════════════════════════════════
     GROUP CREATION MODAL
═══════════════════════════════════════════════════════════════════════════ -->
<app-modal [isOpen]="showGroupModal" (close)="closeGroupModal()" className="max-w-md">
  <div class="flex h-full flex-col overflow-hidden rounded-2xl bg-white shadow-2xl dark:bg-gray-900">

    <!-- Modal Header -->
    <div class="flex items-center justify-between border-b border-gray-200 px-6 py-4 dark:border-gray-700">
      <h3 class="text-base font-semibold text-gray-800 dark:text-white/90">New Group</h3>
      <button (click)="closeGroupModal()" class="text-gray-400 hover:text-gray-600 dark:hover:text-gray-200">
        <svg width="20" height="20" viewBox="0 0 24 24" fill="none">
          <path d="M18 6L6 18M6 6L18 18" stroke="currentColor" stroke-width="2" stroke-linecap="round"/>
        </svg>
      </button>
    </div>

    <div class="max-h-[70vh] space-y-4 overflow-y-auto p-6 custom-scrollbar">

      <!-- Group name -->
      <div>
        <label class="mb-1.5 block text-xs font-medium text-gray-600 dark:text-gray-400">Group Name *</label>
        <input type="text" [(ngModel)]="groupName" placeholder="e.g. Weekend Squad"
               [attr.maxlength]="MAX_GROUP_NAME_LENGTH"
               class="w-full rounded-xl border border-gray-200 bg-gray-50 px-4 py-2.5 text-sm text-gray-800 placeholder:text-gray-400 focus:border-brand-300 focus:outline-none focus:ring-2 focus:ring-brand-500/10 dark:border-gray-700 dark:bg-gray-800 dark:text-white/90">
        <p *ngIf="groupName.length >= MAX_GROUP_NAME_LENGTH" class="mt-1 text-xs text-error-500">Maximum length reached</p>
      </div>

      <!-- Group description -->
      <div>
        <label class="mb-1.5 block text-xs font-medium text-gray-600 dark:text-gray-400">Description <span class="text-gray-400">(optional)</span></label>
        <input type="text" [(ngModel)]="groupDescription" placeholder="What's this group about?"
               maxlength="500"
               class="w-full rounded-xl border border-gray-200 bg-gray-50 px-4 py-2.5 text-sm text-gray-800 placeholder:text-gray-400 focus:border-brand-300 focus:outline-none focus:ring-2 focus:ring-brand-500/10 dark:border-gray-700 dark:bg-gray-800 dark:text-white/90">
      </div>

      <!-- Selected members chips -->
      <div *ngIf="selectedFriends.length > 0">
        <label class="mb-2 block text-xs font-medium text-gray-600 dark:text-gray-400">
          Selected ({{ selectedFriends.length }})
        </label>
        <div class="flex flex-wrap gap-2">
          <div *ngFor="let f of selectedFriends"
               class="flex items-center gap-1.5 rounded-full border border-brand-200 bg-brand-50 pl-1 pr-2 py-0.5 dark:border-brand-700 dark:bg-brand-900/20">
            <img [src]="f.profileImage?.urlSmall || '/images/user/user-default.svg'" [alt]="f.displayName"
                 class="h-5 w-5 rounded-full object-cover">
            <span class="text-xs font-medium text-brand-700 dark:text-brand-300">{{ f.displayName }}</span>
            <button (click)="toggleFriendSelection(f)" class="ml-0.5 text-brand-400 hover:text-brand-600">
              <svg width="10" height="10" viewBox="0 0 24 24" fill="none">
                <path d="M18 6L6 18M6 6L18 18" stroke="currentColor" stroke-width="2.5" stroke-linecap="round"/>
              </svg>
            </button>
          </div>
        </div>
      </div>

      <!-- Friend search -->
      <div>
        <label class="mb-1.5 block text-xs font-medium text-gray-600 dark:text-gray-400">Add Members</label>
        <div class="relative mb-2">
          <svg class="absolute left-3 top-1/2 -translate-y-1/2 fill-gray-400" width="14" height="14" viewBox="0 0 20 20">
            <path fill-rule="evenodd" clip-rule="evenodd" d="M3.04199 9.37381C3.04199 5.87712 5.87735 3.04218 9.37533 3.04218C12.8733 3.04218 15.7087 5.87712 15.7087 9.37381C15.7087 12.8705 12.8733 15.7055 9.37533 15.7055C5.87735 15.7055 3.04199 12.8705 3.04199 9.37381ZM9.37533 1.54218C5.04926 1.54218 1.54199 5.04835 1.54199 9.37381C1.54199 13.6993 5.04926 17.2055 9.37533 17.2055C11.2676 17.2055 13.0032 16.5346 14.3572 15.4178L17.1773 18.2381C17.4702 18.531 17.945 18.5311 18.2379 18.2382C18.5308 17.9453 18.5309 17.4704 18.238 17.1775L15.4182 14.3575C16.5367 13.0035 17.2087 11.2671 17.2087 9.37381C17.2087 5.04835 13.7014 1.54218 9.37533 1.54218Z"/>
          </svg>
          <input type="text" [(ngModel)]="friendSearch" placeholder="Search friends…"
                 class="w-full rounded-xl border border-gray-200 bg-gray-50 py-2 pl-9 pr-4 text-sm text-gray-800 placeholder:text-gray-400 focus:border-brand-300 focus:outline-none focus:ring-2 focus:ring-brand-500/10 dark:border-gray-700 dark:bg-gray-800 dark:text-white/90">
        </div>

        <!-- Friends list -->
        <div class="max-h-48 space-y-1 overflow-y-auto custom-scrollbar">
          <div *ngFor="let friend of filteredAvailableFriends"
               (click)="toggleFriendSelection(friend)"
               [class.bg-brand-50]="isFriendSelected(friend)"
               [class.dark:bg-brand-900\/20]="isFriendSelected(friend)"
               class="flex cursor-pointer items-center gap-3 rounded-xl p-2.5 transition-colors hover:bg-gray-50 dark:hover:bg-white/5">
            <img [src]="friend.profileImage?.urlSmall || '/images/user/user-default.svg'" [alt]="friend.displayName"
                 class="h-9 w-9 flex-shrink-0 rounded-full object-cover">
            <div class="flex-1 min-w-0">
              <p class="truncate text-sm font-medium text-gray-800 dark:text-white/90">{{ friend.displayName }}</p>
              <p class="truncate text-xs text-gray-400">@{{ friend.userName }}</p>
            </div>
            <!-- Checkmark -->
            <div [class.bg-brand-500]="isFriendSelected(friend)"
                 [class.border-brand-500]="isFriendSelected(friend)"
                 [class.border-gray-300]="!isFriendSelected(friend)"
                 class="flex h-5 w-5 flex-shrink-0 items-center justify-center rounded-full border-2 transition-colors">
              <svg *ngIf="isFriendSelected(friend)" width="10" height="10" viewBox="0 0 24 24" fill="none">
                <path d="M5 13L9 17L19 7" stroke="white" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round"/>
              </svg>
            </div>
          </div>

          <p *ngIf="filteredAvailableFriends.length === 0"
             class="py-4 text-center text-sm text-gray-400">No friends found</p>
        </div>
      </div>
    </div>

    <!-- Modal Footer -->
    <div class="flex items-center justify-end gap-3 border-t border-gray-200 px-6 py-4 dark:border-gray-700">
      <button (click)="closeGroupModal()"
              class="rounded-xl border border-gray-300 px-4 py-2 text-sm font-medium text-gray-600 transition-colors hover:bg-gray-50 dark:border-gray-600 dark:text-gray-400 dark:hover:bg-white/5">
        Cancel
      </button>
      <button (click)="createGroup()"
              [disabled]="!groupName.trim() || selectedFriends.length < 1"
              class="rounded-xl bg-brand-500 px-4 py-2 text-sm font-semibold text-white transition-colors hover:bg-brand-600 disabled:cursor-not-allowed disabled:opacity-40">
        Create Group
      </button>
    </div>
  </div>
</app-modal>

<!-- ═══════════════════════════════════════════════════════════════════════════
     GROUP INFO MODAL (name, members, admin controls)
═══════════════════════════════════════════════════════════════════════════ -->
<app-modal [isOpen]="showGroupInfoModal" (close)="closeGroupInfoModal()" className="max-w-lg">
  <ng-container *ngIf="activeConversation$ | async as conv">
    <div class="flex h-full flex-col overflow-hidden rounded-2xl bg-white shadow-2xl dark:bg-gray-900">
      <!-- Header -->
      <div class="flex items-center justify-between border-b border-gray-200 px-6 py-4 dark:border-gray-700">
        <h3 class="text-base font-semibold text-gray-800 dark:text-white/90">Group Info</h3>
        <button (click)="closeGroupInfoModal()" class="text-gray-400 hover:text-gray-600 dark:hover:text-gray-200">
          <svg width="20" height="20" viewBox="0 0 24 24" fill="none"><path d="M18 6L6 18M6 6L18 18" stroke="currentColor" stroke-width="2" stroke-linecap="round"/></svg>
        </button>
      </div>

      <div class="overflow-y-auto max-h-[75vh] custom-scrollbar">
        <!-- Group avatar (admin only) -->
        <div class="flex flex-col items-center gap-2 p-6 border-b border-gray-100 dark:border-gray-800">
          <div class="relative">
            <img [src]="groupEditImagePreview || conv.groupImageUrl || '/images/user/user-default.svg'"
                 class="h-20 w-20 rounded-full object-cover border border-gray-200 dark:border-gray-700">
            <label *ngIf="isGroupAdmin(conv)"
                   class="absolute -bottom-1 -right-1 flex h-7 w-7 cursor-pointer items-center justify-center rounded-full bg-brand-500 text-white shadow hover:bg-brand-600 transition-colors">
              <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
                <path d="M23 19a2 2 0 0 1-2 2H3a2 2 0 0 1-2-2V8a2 2 0 0 1 2-2h4l2-3h6l2 3h4a2 2 0 0 1 2 2Z"/>
                <circle cx="12" cy="13" r="4"/>
              </svg>
              <input type="file" accept="image/*,.jfif,.heic,.heif" class="hidden" (change)="onGroupImageSelected($event)">
            </label>
          </div>
          <button *ngIf="groupEditImagePreview" (click)="clearGroupImageSelection()"
                  class="text-xs font-medium text-gray-400 hover:text-error-500">Cancel new photo</button>
        </div>

        <!-- Group name edit (admin only) -->
        <div class="p-6 border-b border-gray-100 dark:border-gray-800">
          <label class="mb-1.5 block text-xs font-medium text-gray-600 dark:text-gray-400">Group Name</label>
          <div class="flex gap-2">
            <div class="relative flex-1">
              <input type="text" [(ngModel)]="groupEditName"
                     [disabled]="!isGroupAdmin(conv)"
                     [attr.maxlength]="MAX_GROUP_NAME_LENGTH"
                     class="w-full rounded-xl border border-gray-200 bg-gray-50 px-4 py-2 pr-10 text-sm text-gray-800 focus:border-brand-300 focus:outline-none focus:ring-2 focus:ring-brand-500/10 dark:border-gray-700 dark:bg-gray-800 dark:text-white/90 disabled:opacity-50">
              <button *ngIf="isGroupAdmin(conv)" type="button"
                      (click)="toggleGroupNameEmojiPicker($event)"
                      [class.text-brand-500]="showGroupNameEmojiPicker"
                      class="absolute right-2 top-1/2 -translate-y-1/2 text-gray-400 hover:text-brand-500"
                      title="Add emoji">
                <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
                  <circle cx="12" cy="12" r="10"/>
                  <path d="M8 14s1.5 2 4 2 4-2 4-2"/>
                  <line x1="9" y1="9" x2="9.01" y2="9"/>
                  <line x1="15" y1="9" x2="15.01" y2="9"/>
                </svg>
              </button>

              <!-- Emoji picker panel -->
              <div *ngIf="showGroupNameEmojiPicker"
                   class="absolute top-full left-0 mt-2 w-72 rounded-2xl border border-gray-200 bg-white shadow-xl z-[500] overflow-hidden dark:bg-gray-900 dark:border-gray-700"
                   (click)="$event.stopPropagation()">
                <div class="flex border-b border-gray-100 dark:border-gray-800 px-2 pt-2 gap-1">
                  <button *ngFor="let cat of EMOJI_CATEGORIES; let i = index"
                          (click)="setGroupEmojiTab(i)"
                          class="px-3 py-1.5 rounded-lg text-xs font-semibold transition-colors"
                          [class.bg-brand-500]="activeGroupEmojiTab === i"
                          [class.text-white]="activeGroupEmojiTab === i"
                          [class.text-gray-500]="activeGroupEmojiTab !== i"
                          [class.hover:bg-gray-100]="activeGroupEmojiTab !== i">
                    {{ cat.label }}
                  </button>
                </div>
                <div class="flex flex-wrap gap-0.5 p-3 max-h-44 overflow-y-auto">
                  <button *ngFor="let emoji of EMOJI_CATEGORIES[activeGroupEmojiTab].emojis"
                          (click)="pickGroupNameEmoji(emoji)"
                          class="text-xl w-9 h-9 flex items-center justify-center rounded-lg hover:bg-gray-100 dark:hover:bg-white/10 hover:scale-110 transition-all">
                    {{ emoji }}
                  </button>
                </div>
              </div>
            </div>
            <button *ngIf="isGroupAdmin(conv)"
                    (click)="saveGroupName(conv)"
                    [disabled]="!groupEditName.trim() && !groupEditImageFile"
                    class="rounded-xl bg-brand-500 px-4 py-2 text-sm font-semibold text-white hover:bg-brand-600 disabled:opacity-40">Save</button>
          </div>
          <p *ngIf="groupEditName.length >= MAX_GROUP_NAME_LENGTH" class="mt-1.5 text-xs text-error-500">Maximum length reached</p>
        </div>

        <!-- Group description -->
        <div class="p-6 border-b border-gray-100 dark:border-gray-800">
          <label class="mb-1.5 block text-xs font-medium text-gray-600 dark:text-gray-400">Description</label>
          <ng-container *ngIf="isGroupAdmin(conv); else descriptionReadOnly">
            <textarea [(ngModel)]="groupEditDescription" rows="2" placeholder="What's this group about?"
                      class="w-full resize-none rounded-xl border border-gray-200 bg-gray-50 px-4 py-2 text-sm text-gray-800 focus:border-brand-300 focus:outline-none focus:ring-2 focus:ring-brand-500/10 dark:border-gray-700 dark:bg-gray-800 dark:text-white/90"></textarea>
          </ng-container>
          <ng-template #descriptionReadOnly>
            <p class="text-sm text-gray-600 dark:text-gray-300 whitespace-pre-wrap">
              {{ conv.groupDescription || 'No description' }}
            </p>
          </ng-template>
        </div>

        <!-- Admin controls -->
        <div *ngIf="isGroupAdmin(conv)" class="p-6 border-b border-gray-100 dark:border-gray-800">
          <h4 class="mb-3 text-xs font-semibold text-gray-500 dark:text-gray-400 uppercase tracking-wide">Admin Controls</h4>
          <label class="flex cursor-pointer items-center justify-between rounded-xl border border-gray-200 p-3 dark:border-gray-700">
            <div>
              <p class="text-sm font-medium text-gray-800 dark:text-white/90">Only admins can send messages</p>
              <p class="text-xs text-gray-400 dark:text-gray-500">Members can still read messages</p>
            </div>
            <div (click)="toggleOnlyAdmins(conv)"
                 [class.bg-brand-500]="conv.onlyAdminsCanSend"
                 [class.bg-gray-200]="!conv.onlyAdminsCanSend"
                 [class.dark:bg-gray-700]="!conv.onlyAdminsCanSend"
                 class="relative h-6 w-11 flex-shrink-0 rounded-full transition-colors cursor-pointer">
              <span [class.translate-x-5]="conv.onlyAdminsCanSend"
                    [class.translate-x-1]="!conv.onlyAdminsCanSend"
                    class="inline-block h-4 w-4 rounded-full bg-white shadow transform transition-transform mt-1"></span>
            </div>
          </label>
        </div>

        <!-- Members list -->
        <div class="p-6">
          <div class="flex items-center justify-between mb-3">
            <h4 class="text-xs font-semibold text-gray-500 dark:text-gray-400 uppercase tracking-wide">
              Members ({{ conv.memberCount ?? conv.participants.length }})
            </h4>
            <button *ngIf="isGroupAdmin(conv)"
                    (click)="closeGroupInfoModal(); openAddMemberModal()"
                    class="text-xs font-semibold text-brand-500 hover:text-brand-600">+ Add member</button>
          </div>

          <div class="space-y-2">
            <div *ngFor="let member of conv.participants"
                 class="flex items-center gap-3 rounded-xl p-2 hover:bg-gray-50 dark:hover:bg-white/5">
              <img [src]="member.profileImage?.urlSmall || '/images/user/user-default.svg'"
                   class="h-9 w-9 rounded-full object-cover flex-shrink-0">
              <div class="flex-1 min-w-0">
                <p class="text-sm font-medium text-gray-800 dark:text-white/90 truncate">{{ member.displayName }}</p>
                <p class="text-xs text-gray-400 truncate">@{{ member.userName }}</p>
              </div>
              <!-- Role badges -->
              <span *ngIf="(conv.groupAdmins ?? []).includes(member._id)"
                    class="flex-shrink-0 rounded-full bg-brand-100 px-2 py-0.5 text-[10px] font-bold text-brand-700 dark:bg-brand-900/30 dark:text-brand-400">
                Admin
              </span>
              <span *ngIf="isMemberDisabled(conv, member._id)"
                    class="flex-shrink-0 rounded-full bg-error-100 px-2 py-0.5 text-[10px] font-bold text-error-600 dark:bg-error-900/30 dark:text-error-400">
                Muted
              </span>
              <!-- Admin actions (not on self) -->
              <div *ngIf="isGroupAdmin(conv) && member._id !== myId" class="flex gap-1 flex-shrink-0">
                <button (click)="toggleMemberDisabled(conv, member._id)"
                        [title]="isMemberDisabled(conv, member._id) ? 'Unmute member' : 'Mute member'"
                        class="p-1 rounded-lg text-gray-400 hover:text-amber-500 hover:bg-amber-50 dark:hover:bg-amber-900/20 transition-colors">
                  <svg width="14" height="14" viewBox="0 0 24 24" fill="none">
                    <path d="M11 5L6 9H2V15H6L11 19V5ZM23 9L17 15M17 9L23 15" stroke="currentColor" stroke-width="1.5" stroke-linecap="round"/>
                  </svg>
                </button>
                <button (click)="removeMember(conv, member._id)"
                        title="Remove member"
                        class="p-1 rounded-lg text-gray-400 hover:text-error-500 hover:bg-error-50 dark:hover:bg-error-900/20 transition-colors">
                  <svg width="14" height="14" viewBox="0 0 24 24" fill="none">
                    <path d="M16 11C18.2091 11 20 9.20914 20 7C20 4.79086 18.2091 3 16 3M22 21C22 19.0187 20.6693 17.3335 18.8834 16.6211M13 7C13 9.20914 11.2091 11 9 11C6.79086 11 5 9.20914 5 7C5 4.79086 6.79086 3 9 3C11.2091 3 13 4.79086 13 7ZM2 21C2 17.134 5.13401 14 9 14C12.866 14 16 17.134 16 21H2Z" stroke="currentColor" stroke-width="1.5" stroke-linecap="round"/>
                  </svg>
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </ng-container>
</app-modal>

<!-- ═══════════════════════════════════════════════════════════════════════════
     ADD MEMBER MODAL
═══════════════════════════════════════════════════════════════════════════ -->
<app-modal [isOpen]="showAddMemberModal" (close)="closeAddMemberModal()" className="max-w-md">
  <div class="flex h-full flex-col overflow-hidden rounded-2xl bg-white shadow-2xl dark:bg-gray-900">
    <div class="flex items-center justify-between border-b border-gray-200 px-6 py-4 dark:border-gray-700">
      <h3 class="text-base font-semibold text-gray-800 dark:text-white/90">Add Member</h3>
      <button (click)="closeAddMemberModal()" class="text-gray-400 hover:text-gray-600 dark:hover:text-gray-200">
        <svg width="20" height="20" viewBox="0 0 24 24" fill="none"><path d="M18 6L6 18M6 6L18 18" stroke="currentColor" stroke-width="2" stroke-linecap="round"/></svg>
      </button>
    </div>
    <div class="p-4">
      <div class="relative mb-3">
        <svg class="absolute left-3 top-1/2 -translate-y-1/2 fill-gray-400" width="14" height="14" viewBox="0 0 20 20"><path fill-rule="evenodd" clip-rule="evenodd" d="M3.04199 9.37381C3.04199 5.87712 5.87735 3.04218 9.37533 3.04218C12.8733 3.04218 15.7087 5.87712 15.7087 9.37381C15.7087 12.8705 12.8733 15.7055 9.37533 15.7055C5.87735 15.7055 3.04199 12.8705 3.04199 9.37381ZM9.37533 1.54218C5.04926 1.54218 1.54199 5.04835 1.54199 9.37381C1.54199 13.6993 5.04926 17.2055 9.37533 17.2055C11.2676 17.2055 13.0032 16.5346 14.3572 15.4178L17.1773 18.2381C17.4702 18.531 17.945 18.5311 18.2379 18.2382C18.5308 17.9453 18.5309 17.4704 18.238 17.1775L15.4182 14.3575C16.5367 13.0035 17.2087 11.2671 17.2087 9.37381C17.2087 5.04835 13.7014 1.54218 9.37533 1.54218Z"/></svg>
        <input type="text" [(ngModel)]="addMemberSearch" placeholder="Search friends…"
               class="w-full rounded-xl border border-gray-200 bg-gray-50 py-2 pl-9 pr-4 text-sm focus:border-brand-300 focus:outline-none dark:border-gray-700 dark:bg-gray-800 dark:text-white/90">
      </div>
      <div class="max-h-64 overflow-y-auto custom-scrollbar space-y-1">
        <div *ngFor="let friend of filteredAddMemberResults"
             (click)="addMember(friend)"
             class="flex cursor-pointer items-center gap-3 rounded-xl p-3 hover:bg-gray-50 dark:hover:bg-white/5 transition-colors">
          <img [src]="friend.profileImage?.urlSmall || '/images/user/user-default.svg'"
               class="h-9 w-9 rounded-full object-cover flex-shrink-0">
          <div class="flex-1 min-w-0">
            <p class="text-sm font-medium text-gray-800 dark:text-white/90 truncate">{{ friend.displayName }}</p>
            <p class="text-xs text-gray-400 truncate">@{{ friend.userName }}</p>
          </div>
          <svg width="16" height="16" viewBox="0 0 24 24" fill="none" class="text-gray-300">
            <path d="M12 5V19M5 12H19" stroke="currentColor" stroke-width="1.5" stroke-linecap="round"/>
          </svg>
        </div>
        <p *ngIf="filteredAddMemberResults.length === 0" class="py-6 text-center text-sm text-gray-400">No friends to add</p>
      </div>
    </div>
  </div>
</app-modal>

<!-- ── Delete / Clear / Leave options popup ─────────────────────────────────── -->
<app-modal [isOpen]="showDeleteOptionsModal" (close)="closeDeleteOptionsModal()" className="max-w-sm">
  <div class="flex h-full flex-col overflow-hidden rounded-2xl bg-white shadow-2xl dark:bg-gray-900">
    <ng-container *ngIf="deleteOptionsConv as conv">

      <!-- ── DM: single confirm ──────────────────────────────────────────── -->
      <ng-container *ngIf="conv.type === 'DM'">
        <div class="flex items-center justify-between border-b border-gray-200 px-6 py-4 dark:border-gray-700">
          <h3 class="text-base font-semibold text-gray-800 dark:text-white/90">Delete chat</h3>
          <button (click)="closeDeleteOptionsModal()" class="text-gray-400 hover:text-gray-600 dark:hover:text-gray-200">
            <svg width="20" height="20" viewBox="0 0 24 24" fill="none"><path d="M18 6L6 18M6 6L18 18" stroke="currentColor" stroke-width="2" stroke-linecap="round"/></svg>
          </button>
        </div>
        <div class="p-6">
          <p class="text-sm text-gray-600 dark:text-gray-300">
            This will clear the chat with <span class="font-semibold">{{ getConversationName(conv) }}</span> for you only. They'll still see the messages on their side.
          </p>
          <div class="mt-5 flex justify-end gap-2">
            <button (click)="closeDeleteOptionsModal()"
                    class="rounded-xl px-4 py-2 text-sm font-semibold text-gray-600 hover:bg-gray-100 dark:text-gray-300 dark:hover:bg-white/10">Cancel</button>
            <button (click)="clearChat(conv)"
                    class="rounded-xl bg-error-500 px-4 py-2 text-sm font-semibold text-white hover:bg-error-600">Delete chat</button>
          </div>
        </div>
      </ng-container>

      <!-- ── GROUP: Clear chat / Leave group / (admin) Delete group ─────────── -->
      <ng-container *ngIf="conv.type === 'GROUP'">
        <div class="flex items-center justify-between border-b border-gray-200 px-6 py-4 dark:border-gray-700">
          <h3 class="text-base font-semibold text-gray-800 dark:text-white/90">{{ getConversationName(conv) }}</h3>
          <button (click)="closeDeleteOptionsModal()" class="text-gray-400 hover:text-gray-600 dark:hover:text-gray-200">
            <svg width="20" height="20" viewBox="0 0 24 24" fill="none"><path d="M18 6L6 18M6 6L18 18" stroke="currentColor" stroke-width="2" stroke-linecap="round"/></svg>
          </button>
        </div>

        <!-- Option list (no destructive step being confirmed yet) -->
        <div *ngIf="!deleteOptionsConfirming" class="p-2">
          <button (click)="clearChat(conv)"
                  class="flex w-full items-center gap-3 rounded-xl px-4 py-3 text-left text-sm text-gray-700 hover:bg-gray-50 dark:text-gray-200 dark:hover:bg-white/5">
            <svg width="18" height="18" viewBox="0 0 24 24" fill="none" class="flex-shrink-0 text-gray-400">
              <path d="M3 6H21M8 6V4a1 1 0 011-1h6a1 1 0 011 1v2m3 0-1 14a2 2 0 01-2 2H8a2 2 0 01-2-2L5 6" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
            </svg>
            <div>
              <p class="font-medium">Clear chat</p>
              <p class="text-xs text-gray-400">Wipes messages for you only — you stay a member</p>
            </div>
          </button>

          <button (click)="askConfirmDeleteOption('leave')"
                  class="flex w-full items-center gap-3 rounded-xl px-4 py-3 text-left text-sm text-error-500 hover:bg-error-50 dark:hover:bg-error-500/10">
            <svg width="18" height="18" viewBox="0 0 24 24" fill="none" class="flex-shrink-0">
              <path d="M9 21H5a2 2 0 01-2-2V5a2 2 0 012-2h4M16 17l5-5-5-5M21 12H9" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
            </svg>
            <div>
              <p class="font-medium">Leave group</p>
              <p class="text-xs text-error-400">You'll be removed — the group continues for others</p>
            </div>
          </button>

          <!-- Admins (incl. the owner, who is always the first admin) only -->
          <button *ngIf="isGroupAdmin(conv)" (click)="askConfirmDeleteOption('delete')"
                  class="flex w-full items-center gap-3 rounded-xl px-4 py-3 text-left text-sm text-error-600 hover:bg-error-50 dark:hover:bg-error-500/10">
            <svg width="18" height="18" viewBox="0 0 24 24" fill="none" class="flex-shrink-0">
              <path d="M3 6H21M19 6L18.1991 18.0129C18.129 19.065 18.0939 19.5911 17.8667 19.99C17.6666 20.3412 17.3648 20.6235 17.0011 20.7998C16.588 21 16.0607 21 15.0062 21H8.99377C7.93927 21 7.41202 21 6.99889 20.7998C6.63517 20.6235 6.33339 20.3412 6.13332 19.99C5.90607 19.5911 5.871 19.065 5.80086 18.0129L5 6M10 11V17M14 11V17M15 6V4C15 3.44772 14.5523 3 14 3H10C9.44772 3 9 3.44772 9 4V6" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
            </svg>
            <div>
              <p class="font-medium">Delete group</p>
              <p class="text-xs text-error-400">Permanently deletes it for every member — can't be undone</p>
            </div>
          </button>
        </div>

        <!-- Confirm: leave -->
        <div *ngIf="deleteOptionsConfirming === 'leave'" class="p-6">
          <p class="text-sm text-gray-600 dark:text-gray-300">
            Leave <span class="font-semibold">{{ getConversationName(conv) }}</span>? You won't receive messages from this group anymore.
          </p>
          <p *ngIf="isGroupAdmin(conv) && conv.groupAdmins?.length === 1" class="mt-2 text-xs text-gray-400">
            You're the only admin — another member will automatically become admin when you leave.
          </p>
          <div class="mt-5 flex justify-end gap-2">
            <button (click)="cancelConfirmDeleteOption()"
                    class="rounded-xl px-4 py-2 text-sm font-semibold text-gray-600 hover:bg-gray-100 dark:text-gray-300 dark:hover:bg-white/10">Cancel</button>
            <button (click)="leaveGroup(conv)"
                    class="rounded-xl bg-error-500 px-4 py-2 text-sm font-semibold text-white hover:bg-error-600">Leave group</button>
          </div>
        </div>

        <!-- Confirm: delete for everyone -->
        <div *ngIf="deleteOptionsConfirming === 'delete'" class="p-6">
          <p class="text-sm text-gray-600 dark:text-gray-300">
            Permanently delete <span class="font-semibold">{{ getConversationName(conv) }}</span> for every member? This can't be undone.
          </p>
          <div class="mt-5 flex justify-end gap-2">
            <button (click)="cancelConfirmDeleteOption()"
                    class="rounded-xl px-4 py-2 text-sm font-semibold text-gray-600 hover:bg-gray-100 dark:text-gray-300 dark:hover:bg-white/10">Cancel</button>
            <button (click)="deleteGroupForEveryone(conv)"
                    class="rounded-xl bg-error-500 px-4 py-2 text-sm font-semibold text-white hover:bg-error-600">Delete for everyone</button>
          </div>
        </div>
      </ng-container>

    </ng-container>
  </div>
</app-modal>

<!-- ═══════════════════════════════════════════════════════════════════════════
     MEDIA LIGHTBOX PREVIEW
═══════════════════════════════════════════════════════════════════════════ -->
<app-modal [isOpen]="!!previewAttachment" (close)="closeMediaPreview()" className="max-w-4xl bg-black dark:bg-black overflow-hidden">
  <ng-container *ngIf="previewAttachment">
    <!-- Header bar -->
    <div class="flex items-center justify-between px-4 py-3 bg-black/70">
      <span class="text-sm text-white/70 truncate max-w-[80%]">
        {{ previewAttachment.fileName || 'Media preview' }}
      </span>
      <div class="flex items-center gap-2">
        <a [href]="previewAttachment.url" [download]="previewAttachment.fileName || 'media'" target="_blank"
           class="flex h-8 w-8 items-center justify-center rounded-full text-white/70 hover:bg-white/10 hover:text-white transition-colors"
           title="Download">
          <svg width="16" height="16" viewBox="0 0 24 24" fill="none">
            <path d="M21 15V19C21 19.5304 20.7893 20.0391 20.4142 20.4142C20.0391 20.7893 19.5304 21 19 21H5C4.46957 21 3.96086 20.7893 3.58579 20.4142C3.21071 20.0391 3 19.5304 3 19V15M7 10L12 15M12 15L17 10M12 15V3" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
          </svg>
        </a>
        <button (click)="closeMediaPreview()"
                class="flex h-8 w-8 items-center justify-center rounded-full text-white/70 hover:bg-white/10 hover:text-white transition-colors">
          <svg width="16" height="16" viewBox="0 0 24 24" fill="none">
            <path d="M18 6L6 18M6 6L18 18" stroke="currentColor" stroke-width="2" stroke-linecap="round"/>
          </svg>
        </button>
      </div>
    </div>

    <!-- Image -->
    <div *ngIf="previewAttachment.mimeType.startsWith('image/')"
         class="flex items-center justify-center bg-black p-4" style="min-height: 60vh">
      <img [src]="previewAttachment.url"
           class="max-h-[75vh] max-w-full rounded-lg object-contain select-none">
    </div>

    <!-- Video -->
    <div *ngIf="previewAttachment.mimeType.startsWith('video/')"
         class="flex items-center justify-center bg-black">
      <video [src]="previewAttachment.url"
             controls
             autoplay
             class="max-h-[75vh] max-w-full"></video>
    </div>

    <!-- Audio -->
    <div *ngIf="previewAttachment.mimeType.startsWith('audio/')"
         class="flex flex-col items-center justify-center gap-4 bg-gray-900 p-10">
      <svg class="text-white/30" width="48" height="48" viewBox="0 0 24 24" fill="none">
        <path d="M9 18V5L21 3V16M9 18C9 19.1046 8.10457 20 7 20C5.89543 20 5 19.1046 5 18C5 16.8954 5.89543 16 7 16C8.10457 16 9 16.8954 9 18ZM21 16C21 17.1046 20.1046 18 19 18C17.8954 18 17 17.1046 17 16C17 14.8954 17.8954 14 19 14C20.1046 14 21 14.8954 21 16Z" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
      </svg>
      <p class="text-white/60 text-sm">{{ previewAttachment.fileName || 'Audio' }}</p>
      <audio [src]="previewAttachment.url" controls autoplay class="w-full"></audio>
    </div>
  </ng-container>
</app-modal>